{
  "Aid_object": {
    "Delete item": "Remove aid object",
    "Delete item fail": "Error removing the aid object.",
    "Delete item success": "Aid object successfully removed.",
    "Delete item text": "Are you sure you want to {1} the aid object {0}?",
    "Edit item": "Edit aid object",
    "Edit item fail": "Error editing the aid object. Aid object not modified.",
    "Edit item success": "Tool successfully modified.",
    "Name": "Name",
    "New item": "New aid object",
    "New item fail": "Error creating the new aid object.",
    "New item success": "Aid object successfully made.",
    "ObjectName": "Aid object",
    "Phone_number": "Phone number",
    "Registration_number": "Registration number",
    "Responsible": "Responsible"
  },
  "Apply": "Apply",
  "Authmanagement-roles": {
    "Auth source": "Authentication Source",
    "Delete": "Remove",
    "Delete item": "Delete role",
    "Delete item fail": "The scroll could not be removed.",
    "Delete item success": "Role successfully deleted",
    "Delete item text": "Are you sure you want to {1} the role {0}?",
    "Edit item": "Change Role",
    "Edit item fail": "Error changing the role. Role has not changed.",
    "Edit item success": "Role successfully changed",
    "Name": "Role",
    "New item": "New role",
    "New item fail": "Error creating the role.",
    "New item success": "Role successfully created",
    "Refresh list": "Refresh list of roles"
  },
  "Bathing_swimming_form": {
    "Bathing": "Bathing",
    "Bathing Protocol List": "Bathing and swimming agreements",
    "Bathing_aids": "The following aids are used for this purpose",
    "Bathing_aids_representative": "The following aids are used for this purpose (representative)",
    "Bathing_options": "The participant/resident may",
    "Bathing_options_representative": "The participant/resident may (representative)",
    "Delete item": "Delete bathing and swimming agreements",
    "Delete item fail": "Error in removing the bathing and swimming agreements.",
    "Delete item success": "Bathing and swimming agreements successfully removed.",
    "Delete item text": "Are you sure you want to {1} the bathing and swimming agreements?",
    "Document is cancelled": "The document has expired.",
    "Document is expired": "Please note: the validity of the document has expired!",
    "Document is final": "The document has been finalized and can no longer be changed.",
    "Documents awaits signing by representative": "The document is pending signature of the representative and can no longer be changed.",
    "Documents awaits signing by supplier": "The document is pending signature by Nocht and Wille and can no longer be changed.",
    "Edit item": "Edit bathing and swimming agreements",
    "Edit item fail": "Error editing the baths and swimming agreements. Bathing and swimming agreements have not changed.",
    "Edit item success": "Bathing and swimming agreements successfully changed.",
    "Editable_by": "Editable by",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REPRESENTATIVE_SIGN_CONSENT": "You must give your consent before you can sign the document."
    },
    "Floatation_device": "Flotation devices, namely",
    "Floatation_device_representative": "Flotation devices, namely (representative)",
    "Form client birthdate": "Date of birth",
    "Form client name": "Consent form from",
    "General": "General",
    "New item": "Permission",
    "New item fail": "Error creating the consent form.",
    "New item success": " Consent form successfully created.",
    "Only editable by representative": "The document can currently only be changed by representatives.",
    "Only editable by supplier": "The document can currently only be changed by Nocht and Wille.",
    "Other_bathing_aid": "Other tools, namely",
    "Other_bathing_aid_representative": "Other tools, namely (representative)",
    "Other_swimming_aid": "Other tools, namely",
    "Other_swimming_aid_representative": "Other tools, namely (representative)",
    "Risk_factors": "Risk factors",
    "Risk_factors_notes": "Comments",
    "Risk_factors_notes_representative": "Remarks representative(s)",
    "Risk_factors_representative": "Risk factors representative",
    "Shower_options": "The participant/resident may",
    "Shower_options_representative": "The participant/resident may (representative)",
    "Showering": "Shower",
    "Sign_consent": "Document consent",
    "Sign_consent_text": "I confirm that I have read this document and agree with its contents as described.",
    "Signed_by_employee": "Sign on behalf of Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Signing on behalf of client",
    "Swimming": "Swim",
    "Swimming_aids": "The following aids are used for this purpose",
    "Swimming_aids_representative": "The following aids are used for this purpose (representative)",
    "Swimming_floatation_device": "Flotation devices, namely",
    "Swimming_floatation_device_representative": "Flotation devices, namely (representative)",
    "Swimming_options": "The participant/resident may",
    "Swimming_options_representative": "The participant/resident may (representative)"
  },
  "Behaviourgoal": {
    "Added by": "Added By",
    "Client": "Client",
    "Created": "Created at",
    "Delete item": "Delete behavioral goal",
    "Delete item fail": "Error deleting the behavioral goal.",
    "Delete item success": "Behavioral goal successfully removed.",
    "Delete item text": "Are you sure you want to {1} the behavioral goal {0}?",
    "Edit item": "Edit behavioral goal",
    "Edit item fail": "Error editing the behavioral goal. Behavioral goal not changed.",
    "Edit item success": "Behavioral goal successfully changed.",
    "Export item": "Export behavioral goal",
    "Export item fail": "Error exporting the behavioral goal.",
    "Export item success": "Behavioral goal successfully exported.",
    "Goal": "Behavioral goal",
    "Goal expired per": "finished per {date}",
    "Message": "Message",
    "Moment": "When",
    "Month": "Month",
    "New item": "New behavioral goal",
    "New item fail": "Error in making the new behavioral goal.",
    "New item success": "Behavioral goal created successful.",
    "Notes": "Comments",
    "Valid_from": "Valid from",
    "Valid_until": "Valid until",
    "Year": "Year"
  },
  "Behaviourgoalmessage": {
    "Added by": "Added By",
    "Author": "Added by",
    "Behaviour_goal": "Behavioral goal",
    "Behaviour_goal__client": "Client",
    "Client": "Client",
    "Color": "Color",
    "Created": "Created at",
    "Delete item": "Delete message",
    "Delete item fail": "Error deleting the message.",
    "Delete item success": "Message successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the {0}?",
    "Duration": "Duration in minutes",
    "Edit item": "Edit message",
    "Edit item fail": "Error editing the message. Message not changed.",
    "Edit item success": "Message successfully modified.",
    "Message": "Message",
    "Moment": "When",
    "New item": "New message",
    "New item fail": "Error creating the new message.",
    "New item success": "Post successfully created.",
    "Notes": "Comments",
    "ObjectName": "Behaviour report | Behaviour report messages",
    "Valid_from": "Valid from",
    "Valid_until": "Valid Until"
  },
  "Camera_surveillance_form": {
    "Answer": "Permission:",
    "Answer_false": "I do not give permission to Nocht en Wille Zorg BV to set up the camera surveillance as indicated.",
    "Answer_representative": "Representative Answer",
    "Answer_true": "I give permission to Nocht en Wille Zorg BV to set up the camera surveillance as indicated.",
    "Consent message": "By signing this form, you, as the legal representative, formally indicate to Nocht en Wille Zorg BV whether or not you want us to use the aforementioned camera surveillance when providing care to your relative.",
    "Delete": "remove",
    "Delete item": "Remove camera and audio surveillance agreements",
    "Delete item fail": "Error when deleting the camera and audio surveillance agreements.",
    "Delete item success": "Camera and audio surveillance agreements successfully removed.",
    "Delete item text": "Are you sure you want to {1} the camera and audio surveillance agreements?",
    "Document is cancelled": "The document has expired.",
    "Document is expired": "Please note: the validity of the document has expired!",
    "Document is final": "The document has been finalized and can no longer be changed.",
    "Documents awaits signing by representative": "The document is pending signature of the representative and can no longer be changed.",
    "Documents awaits signing by supplier": "The document is pending signature by Nocht and Wille and can no longer be changed.",
    "Edit item": "Edit camera and audio surveillance agreements",
    "Edit item fail": "Error editing the camera and audio surveillance agreements. Agreements on camera and audio surveillance have not changed.",
    "Edit item success": "Camera and audio surveillance agreements successfully edited.",
    "Editable_by": "Editable by",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REPRESENTATIVE_SIGN_CONSENT": "You must give your consent before you can sign the document."
    },
    "Form client birthdate": "Date of birth",
    "Form client name": "Consent form of",
    "How does it work": "How does it work?",
    "How does it work explanation": "Each room in the living form and the guest house is equipped with a remote-controlled camera on which image and sound can be detected. Staff can view these camera images on the laptop, on the service phone or from the sleep watchman's room. It is possible to zoom in and rotate per room, it is possible to set the camera in such a way that it reacts faster or less quickly to movement and sound. The system can also send a notification to the staff or to the manager if there is a signal. Camera images are stored on a secure storage medium for a maximum of 2 weeks.",
    "How we handle it": "How do we deal with it?",
    "How we handle it explanation": "In the Netherlands, there is no question yet that supervisory home automation is considered to be one of the so-called means and measures with regard to restriction of freedom. (legal) However, supervisory means can have a freedom-restricting effect. We have to ask ourselves what we want to achieve with the use of the resources, whether there are less drastic means available and whether the use of these resources is effective. Our goal with regard to the use of camera surveillance is to increase the safety of our residents in combination with our desire not to disturb residents unnecessarily during moments of rest. We offer care to people with a very serious mental and/or physical disability, many suffer from epilepsy and no resident is self-reliant.",
    "New item": "Permission form for camera and audio surveillance",
    "New item fail": "Error when making the camera and audio surveillance agreements.",
    "New item success": "Camera and audio surveillance agreements successfully created.",
    "Only editable by representative": "The document can currently only be changed by representatives.",
    "Only editable by supplier": "The document can currently only be changed by Nocht and Wille.",
    "Sign document": "Sign",
    "Sign_consent": "Document consent",
    "Sign_consent_text": "I confirm that I have read this document and agree with its contents as described.",
    "Signed_by_employee": "Sign on behalf of Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Signing on behalf of client",
    "Start signing form message": "Choose the name of the representative and employee who will sign the document.\n\nThe representative will receive an email with a signing request, after signing by the agent, the employee will receive a signing request.",
    "Start signing item": "Making it final",
    "What is it": "What is it?",
    "What is it explanation": "Nocht en Wille Zorg uses so-called supervisory home automation in the housing form and in the guest house.\n\nHome automation in healthcare translates as supporting or supervisory technology. A stairlift is an example of assistive home automation. Camera and audio surveillance is an example of supervisory home automation.\n\nBy operating a camera system, Nocht en Wille Zorg aims to guarantee the safety of residents, especially at moments of rest (night's rest, etc.).\n\nTechnology allows us to see and hear the resident without entering the resident's room and disturbing him or her in his or her peace.\n\nWith these resources, we believe that we can supervise more effectively and quickly provide care and support where necessary. Having said that, we also draw attention to the fact that technology can improve safety and care, but that there are also clear limitations. There will never be 100% security through the use of home automation or any other deployment."
  },
  "Cancel": "Cancel",
  "Change": "Modify",
  "Client": {
    "Added by": "Added By",
    "Address": "Address",
    "Attendant": "Accompanist",
    "Birthday": "Birthday",
    "Bsn_number": "BSN number",
    "City": "Town",
    "Client": "Client",
    "Client info": "Client information",
    "Client name": "Client name",
    "Clientcare__location": "Location",
    "Created": "Added",
    "Date": "Date",
    "Date_of_birth": "Date of Birth",
    "Declarable care delete warning": "This client still has attendance registrations that can be declared. If you continue, these registrations will no longer be included in future declarations. Files and message boards directly linked to this client will be permanently deleted and cannot be restored.",
    "Declarable care delete warning title": "Client has care left to declare",
    "Delete": "archive",
    "Delete file message board warning": "Files and message boards directly linked to this client will be permanently deleted and cannot be restored.",
    "Delete item": "Archive client",
    "Delete item fail": "Error archiving the client.",
    "Delete item success": "Client successfully archived.",
    "Delete item text": "Are you sure you want to {1} client {0}?",
    "Edit item": "Edit Client",
    "Edit item fail": "Error editing the client. Client not changed.",
    "Edit item success": "Client successfully changed.",
    "Edit photo": "Change Photo",
    "Editable by": "Editable by",
    "Employee": "Employee",
    "Errors": {
      "Error loading client data": "Client data could not be retrieved.",
      "NOTHING_TO_EXPORT": "There is no client data to export."
    },
    "Export client": "Export client data",
    "Export client email addresses": "Export client email addresses",
    "Export contact email addresses": "Export contact email addresses",
    "Export location presence": "Attendance registration",
    "First_name": "First Name",
    "Gender": "Gender",
    "GenderOptions": {
      "M": "Husband",
      "O": "Unknown / Not Specified",
      "V": "Wife"
    },
    "General_practitioner": "General practitioner",
    "Goto epilepsy protocol": "Click here to open the epilepsy protocol directly.",
    "House_annex": "Addition",
    "House_number": "House number",
    "ID": "Id",
    "Id_card": "Identification",
    "Indication": "Indication",
    "Initials": "Initials",
    "Insurance": "Insurance",
    "Insurance_card": "Insurance certificate",
    "Insurance_number": "Insurance number",
    "Insurance_supplier": "Insurer",
    "Last_name": "Surname",
    "Last_name_prefix": "Last name prefix",
    "Living_attendant": "Name of manager",
    "Living_attendant_phone": "Supervisor phone",
    "Living_email": "Email address",
    "Living_full_address": "Full address",
    "Living_organization": "Organization",
    "Living_phone": "Phone number",
    "Load all reports": "All Reports",
    "Locations": "Locations",
    "MaritalStatus": "Marital status",
    "MaritalStatusOptions": {
      "Achtergebleven_geregistreerd_partner": "Registered partner left behind",
      "Gehuwd": "Married",
      "Geregistreerd_partner": "Registered partner",
      "Gescheiden": "Divorced",
      "Gescheiden_geregistreerd_partner": "Divorced registered partner",
      "Ongehuwd": "Unmarried",
      "Ongehuwd_geen_geregistreerd_partner": "Unmarried and not a registered partner, possibly married or registered partner",
      "Verweduwd": "Widowed"
    },
    "Medical treatment agreements": "Medical treatment appointments:",
    "More clients": "More clients",
    "Name": "Name",
    "New item": "New client",
    "New item fail": "Error creating the new client.",
    "New item success": "Client made successful",
    "ObjectName": "Client",
    "Overview": "Overview",
    "Personal attendant": "Point of contact | Points of contact",
    "Photo": "Photograph",
    "Postal_code": "Zip code",
    "Recent reports": "Recent reports",
    "Reports": {
      "Behaviour": "Behaviour",
      "Day": "Daily reports",
      "Epilepsy": "Epilepsy",
      "Excrement": "Excrement",
      "Fobo": "FOBO",
      "Food": "Food",
      "Temperature": "Temperature",
      "Weight": "Weight"
    },
    "Representatives": "Representatives",
    "Restore item": "Restore client",
    "Restore item fail": "Error restoring the client.",
    "Restore item success": "Client successfully restored.",
    "Restore item text": "Are you sure you want to restore client {client}?",
    "Show ID": "Show ID card",
    "Show insurance": "Show insurance",
    "ShowArchive": "Show archive",
    "Tabs": {
      "Behaviour reports": "Behavioral reports",
      "Care type per location": "Care type per location",
      "Contacts": "Contacts",
      "Employee roles": "Employee roles",
      "General": "General",
      "Indicatie": "Indication",
      "Living location": "Living location",
      "Locations": "Locations",
      "Representative roles": "Representative roles",
      "Representatives": "Representatives",
      "Vecozo-messages": "Message box"
    },
    "Telephone_number": "Telephone number",
    "Type": "Type",
    "View client": "Open client card",
    "Warnings": {
      "Deleted client": "You're viewing an archived client. It is no longer possible to make changes.",
      "Expired protocol": "The protocol/consent form {type} is expired",
      "Expired supportplan": "The support plan has expired",
      "Hospitalisation": "NO hospitalization",
      "Intensive_care": "NO intensive care admission",
      "No doctor": "No doctor registered",
      "No ID card": "No ID card",
      "No insurance card": "No insurance card",
      "Reanimation": "DO NOT resuscitate",
      "Respiration": "DO NOT ventilate"
    },
    "Weight": "Weight"
  },
  "Client_care": {
    "Always_declare": "Always declare",
    "Client": "Customer",
    "Conflict_action": "Preferable action",
    "Conflicts": "Conflicts",
    "Date": "Date",
    "Days_of_week": "Days",
    "Delete": "Remove",
    "Delete item": "Remove care provision",
    "Delete item fail": "Error in removing the care provision.",
    "Delete item success": "Care provision successfully removed.",
    "Delete item text": "Are you sure you want to {1} the care {0}?",
    "Edit item": "Healthcare Editing",
    "Edit item fail": "Error in editing healthcare.",
    "Edit item success": "Healthcare successfully processed.",
    "End": "End date",
    "Errors": {
      "START_DATE_CANNOT_BE_AFTER_ORIGINAL_END": "The start date must not be later than the original end date!",
      "START_DATE_CANNOT_BE_BEFORE_ORIGINAL_START": "The start date must not be earlier than the original start date",
      "VEKTISPRESTATIE_UPDATE_NOT_ALLOWED": "It is not allowed to change the Vektis performance code",
      "VEKTISTOESLAGEN_UPDATE_NOT_ALLOWED": "It is not allowed to adjust the Vektis surcharges"
    },
    "Location": "Location",
    "Move item": "Move",
    "Move item fail": "Error when moving healthcare services",
    "Move item success": "Healthcare services successfully moved",
    "New item": "New healthcare provision",
    "New item fail": "Error when creating new healthcare provider.",
    "New item success": "New healthcare provision successfully created.",
    "No ZZP": "It is not yet possible for this client to add a care type per location, because there is no assigned care intensity package for this client yet.",
    "ObjectName": "Healthcare",
    "Part_of_day": "Part of day",
    "Start": "Start date",
    "Vecozotoegewezenzorgzwaartepakket": "Assigned CSP",
    "Vektisprestatie": "Vektis performance code",
    "Vektisprestatiegroup": "Vektis performance group",
    "Vektistoeslagen": "Surcharges",
    "ZZP code": "CSP code"
  },
  "Client_user_role": {
    "Assign": "Assign",
    "Client": "Client",
    "Delete item": "Delete role assignment",
    "Delete item fail": "Error deleting the role assignment.",
    "Delete item success": "Role assignment successfully removed.",
    "Delete item text": "Are you sure you want to {1}the role assignment?",
    "Edit item": "Edit role assignment",
    "Edit item fail": "Error changing the role assignment.",
    "Edit item success": "Role assignment successfully changed.",
    "Employees": "Employees",
    "Error loading data": "The list of role assignments could not be loaded.",
    "New item": "New role assignment",
    "New item fail": "Error creating the role assignment.",
    "New item success": "Role assignment successfully added.",
    "Representatives": "Representatives",
    "Role": "Role",
    "Stepper": {
      "Steps": {
        "Select client": "Select Client",
        "Select client description": "Select the client for which you will configure authorizations.",
        "Select client title": "For which client do you want to assign roles?",
        "Select representatives and roles": "Roles per representative",
        "Select representatives and roles description": "Assign specific roles that apply only to the selected representative.",
        "Select representatives and roles title": "Which roles do you want to assign to this client per representative?",
        "Select users and roles": "Roles per employee",
        "Select users and roles description": "Assign specific roles that apply only to the selected employee.",
        "Select users and roles title": "Which roles do you want to assign to this client per employee?",
        "Summary": "Overview",
        "Summary description": "Review all assigned roles per level before saving the configuration.",
        "Summary title": "Summary of role assignments"
      }
    },
    "User": "Employee",
    "Users": "Employees"
  },
  "Contact": {
    "Address": "Address",
    "City": "City",
    "Delete": "Remove",
    "Delete item": "Delete contact",
    "Delete item fail": "Error deleting the contact.",
    "Delete item success": "Contact successfully removed.",
    "Delete item text": "Are you sure you want to {1} contact {0}?",
    "Edit item": "Edit contact",
    "Edit item fail": "Error editing contact.",
    "Edit item success": "Contact successfully edited.",
    "Email": "Email address",
    "Full_address": "Full address",
    "Full_name": "Full name",
    "House_annex": "Annex",
    "House_number": "House number",
    "New item": "New contact",
    "New item fail": "Error creating a new contact.",
    "New item success": "New contact successfully created.",
    "ObjectName": "Contact",
    "Phone_alternative": "Alternative phone number",
    "Phone_number": "Phone number",
    "Phone_primary": "Primary phone number",
    "Postal_code": "Zip code",
    "Type": "Type",
    "TypeOptions": {
      "10": "Parent",
      "11": "Guardian",
      "12": "Partner/spouse",
      "13": "Foster parent",
      "14": "Administrator",
      "15": "Mentor",
      "16": "Son/Daughter",
      "17": "Relative",
      "18": "Family member",
      "19": "Neighbour",
      "20": "Friend/acquaintance",
      "21": "Client supporter",
      "22": "General practitioner",
      "23": "Heirs of",
      "24": "Employer",
      "25": "District coach",
      "03": "Curator (legal)",
      "04": "Financial (authorized)",
      "05": "Financial (assessment)",
      "06": "Living unit",
      "07": "Rescuer",
      "08": "Specialist",
      "09": "Otherwise"
    }
  },
  "Day": {
    "Add recording": "Add audio clip",
    "Added by": "Added By",
    "Attachment": "Attachment",
    "Audio_recording": "Audio recording",
    "Cause": "Cause",
    "Click to open image": "Click to open the image",
    "Click to open PDF": "Click to open the PDF",
    "Client": "Client",
    "Client name": "Client name",
    "Created": "Created at",
    "Date": "Date",
    "Delete item": "Delete Report",
    "Delete item fail": "Error deleting the report.",
    "Delete item success": "Report successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the {0}?",
    "Duration": "Duration",
    "Edit item": "Edit report | Edit report of {client}",
    "Edit item fail": "Error editing the message. Message has not been changed.",
    "Edit item success": "Post updated successfully.",
    "Editable_by": "Editable by",
    "Medicine": "Medicines",
    "Message": "Message",
    "Name": "Name",
    "New item": "New report | New report for {client}",
    "New item fail": "Error creating the message.",
    "New item success": " Post has been successfully created.",
    "Notes": "Notes",
    "Nothing to show": "No posts found.",
    "ObjectName": "Day report | Day report messages",
    "Only show priority messages": "Only show priority messages",
    "Priority": "High priority",
    "Quoted_message": "Message",
    "Shift": "Shift",
    "Time": "Time",
    "When": "When"
  },
  "Dayreportmessage": {
    "Delete": "remove",
    "Delete item": "Delete message",
    "Delete item fail": "Error deleting the message.",
    "Delete item success": "Message successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the message?"
  },
  "Delete": "Remove",
  "Email_log": {
    "Attachments": "Attachments",
    "Bcc": "BCC",
    "Belongs_to": "Belongs to",
    "Cc": "Cc",
    "Content": "Post Content",
    "Created_at": "Created On",
    "Error loading data": "The list of email logs could not be loaded due to an error.",
    "From": "Sender",
    "Mail_sent": "Sent",
    "Mail_sent_at": "Shipped on",
    "New item": "New email",
    "Reply_to": "Reply to",
    "Subject": "Subject",
    "To": "At",
    "ToOptions": {
      "NoBcc": "No 'bcc' address",
      "NoCc": "No 'cc' address",
      "NoFrom": "No 'from' address",
      "NoReplyTo": "No 'reply to' address",
      "NoTo": "No 'to' address"
    },
    "Vendor_response": "Vendor response",
    "View item": "Email log details"
  },
  "Audit_log": {
    "Client_ip": "Client IP",
    "Changes": "Changes",
    "Created_at": "Created On",
    "Data": "Data",
    "Diff": "Diff",
    "Duration_ms": "Duration (ms)",
    "Error_message": "Error message",
    "Error_stack": "Stack trace",
    "Hostname": "Hostname",
    "Impersonated_by": "Impersonated by",
    "Level": "Type",
    "Message": "Message",
    "Method": "Method",
    "Object_id": "Object ID",
    "Original_object": "Original",
    "Path": "Path",
    "Query": "Query",
    "Request_id": "Request ID",
    "Response_data": "Response",
    "Result_object": "Result",
    "Status_code": "Status",
    "User": "User",
    "View item": "Audit log details"
  },
  "Epilepsy": {
    "Added by": "Added By",
    "Cause": "Cause",
    "Client": "Client",
    "Client name": "Client name",
    "Created": "Added on",
    "Date": "Date",
    "Delete item": "Delete Report",
    "Delete item fail": "Error deleting the report.",
    "Delete item success": "Report successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the {0} ?",
    "Duration": "Duration in seconds",
    "Edit item": "Edit report",
    "Edit item fail": "Error editing the epilepsy report. Epilepsy report not changed.",
    "Edit item success": "Epilepsy report successfully updated.",
    "Editable_by": "Editable by",
    "Medicine": "Emergency medication used",
    "Month": "Month",
    "Name": "Name",
    "New item": "New report",
    "New item fail": "Error in making the epilepsy report.",
    "New item success": "Epilepsy report made successful.",
    "Notes": "Notes",
    "ObjectName": "Epilepsy report | Epilepsy reports",
    "Shift": "Shift",
    "Time": "Time",
    "When": "When",
    "Year": "Year"
  },
  "Epilepsy_protocol": {
    "Answer": "Answer",
    "Answer_representative": "Representative Answer",
    "Attachment": "Attachment",
    "Cancelled": "Dilapidated",
    "Delete item": "Remove epilepsy protocol",
    "Delete item fail": "Error in removing the epilepsy protocol.",
    "Delete item success": "Epilepsy protocol successfully removed.",
    "Delete item text": "Are you sure you want to {1} the epilepsy protocol?",
    "Deleted": "Deleted",
    "Description_absence": "Absence",
    "Description_absence_representative": "Note representative(s)",
    "Description_big": "Big seizure",
    "Description_big_representative": "Note representative(s)",
    "Description_small": "Small seizure",
    "Description_small_representative": "Note representative(s)",
    "Document is cancelled": "The document has expired.",
    "Document is expired": "Please note: the validity of the document has expired!",
    "Document is final": "The document has been finalized and can no longer be changed.",
    "Documents awaits signing by representative": "The document is pending signature of the representative and can no longer be changed.",
    "Documents awaits signing by supplier": "The document is pending signature by Nocht and Wille and can no longer be changed.",
    "Edit item": "Epilepsy protocol edit",
    "Edit item fail": "Error editing the epilepsy protocol. Epilepsy protocol not changed.",
    "Edit item success": "Epilepsy protocol successfully updated.",
    "Editable_by": "Editable by",
    "Emergency_services": "Emergency services called?",
    "Emergency_services_representative": "Emergency services called? (representative)",
    "Employee_signature": "Employee signature",
    "Employee_signature_date": "Employee signature date",
    "Epilepsy Protocol List": "Description seizures",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REPRESENTATIVE_SIGN_CONSENT": "You must give your consent before you can sign the document."
    },
    "Form client birthdate": "Date of Birth",
    "Form client name": "Consent form from",
    "Form_valid_until": "Valid Until",
    "Measure time": "Keep an eye on the duration of the coincidence. (if in doubt, administer medication earlier)",
    "Medication": "By a coincidence",
    "Medication_representative": "By a coincidence (representative)",
    "New item": "Permission",
    "New item fail": "Error creating the consent form.",
    "New item success": " Consent form successfully created.",
    "Note in day report": "Note in the daily report that he/she has had a seizure (how much/how long)",
    "Only editable by representative": "The document can currently only be changed by representatives.",
    "Only editable by supplier": "The document can currently only be changed by Nocht and Wille.",
    "Repeat": "Repeat?",
    "Repeat_representative": "Repeat? (representative)",
    "Replaced_by": "Replaced by",
    "Representative_signature": "Representative signature",
    "Representative_signature_date": "Representative signature date",
    "Sign_consent": "Document consent",
    "Sign_consent_text": "I confirm that I have read this document and agree with its contents as described.",
    "Signed_by_employee": "Sign on behalf of Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Signing on behalf of client",
    "Stay close": "Stay close to the person, don't leave him alone, make sure he can't hurt himself on anything.",
    "User": "User",
    "What to do": "WHAT TO DO!",
    "What to do representatives": "Note representative(s)"
  },
  "Excrement": {
    "Added by": "Added By",
    "Amount": "Quantity",
    "Cause": "Cause",
    "Client": "Client",
    "Client name": "Client name",
    "Consistency": "Type",
    "Created": "Creaated at",
    "Date": "Date",
    "Delete item": "Delete Report",
    "Delete item fail": "Error deleting the report.",
    "Delete item success": "Report successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the {0}?",
    "Duration": "Duration",
    "Edit item": "Edit report",
    "Edit item fail": "Error changing the report. Report not changed.",
    "Edit item success": "Report successfully modified.",
    "Editable_by": "Editable by",
    "Medication": "Medications/fluid name",
    "Medicine": "Medicines",
    "Month": "Month",
    "Name": "Name",
    "New item": "New report",
    "New item fail": "Error creating the new report.",
    "New item success": "Report added successfully.",
    "ObjectName": "Excrement report | Excrement reports",
    "Shift": "Shift",
    "Time": "Time",
    "When": "When",
    "Year": "Year"
  },
  "File_insight_form": {
    "Answer": "I give permission for access to the file and all parts of the file for the purpose of. quality controls.",
    "Answer_false": "I do not give permission for access to the file for quality controls.",
    "Answer_representative": "Representative answer",
    "Answer_true": "I give permission for access to the file and all parts of the file for the purpose of quality controls.",
    "Attachment": "Attachment",
    "Cancelled": "Expired",
    "Client": "Client",
    "Consent explanation": "In order to be able to carry out these quality checks, we need your written permission. (see also the folder 'privacy and personal data').",
    "Consent message": "In order to be able to support you as well as possible, your details and agreements between you and Nocht en Wille Zorg are recorded in the support plan. This is important to ensure the quality of care. In order to be able to properly monitor this quality of care, quality checks are sometimes carried out. These can be carried out internally by so-called 'internal auditors', but sometimes they are also carried out externally by 'external auditors' (for the ISO quality mark), or e.g. by the Health and Youth Care Inspectorate. (IGJ)",
    "Delete": "remove",
    "Delete item": "Delete consent form for access to support plan",
    "Delete item fail": "Error deleting the support plan access consent form.",
    "Delete item success": "Consent form for access to support plan successfully removed.",
    "Delete item text": "Are you sure you want to {1} the GP {0}?",
    "Deleted": "Remote",
    "Document is cancelled": "The document has expired.",
    "Document is expired": "Please note: the validity of the document has expired!",
    "Document is final": "The document has been finalized and can no longer be changed.",
    "Documents awaits signing by representative": "The document is pending signature of the representative and can no longer be changed.",
    "Documents awaits signing by supplier": "The document is pending signature by Nocht and Wille and can no longer be changed.",
    "Edit item": "Edit consent form for access to support plan",
    "Edit item fail": "Error when changing the consent form for access to the support plan.",
    "Edit item success": "Consent form for access to support plan successfully amended.",
    "Editable_by": "Editable by",
    "Employee_signature": "Employee signature",
    "Employee_signature_date": "Employee signature date",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REPRESENTATIVE_SIGN_CONSENT": "You must give your consent before you can sign the document."
    },
    "Form client birthdate": "Date of Birth",
    "Form client name": "Consent form from",
    "Form_valid_until": "Valid Until",
    "Insight Protocol List": "Permission to inspect the support plan",
    "New item": "Permission to inspect the support plan",
    "New item fail": "Error when creating the consent form for access to the support plan.",
    "New item success": " Consent form for access to support plan successfully added.",
    "Only editable by representative": "The document can currently only be changed by representatives.",
    "Only editable by supplier": "The document can currently only be changed by Nocht and Wille.",
    "Replaced_by": "Replaced by",
    "Representative_signature": "Representative signature",
    "Representative_signature_date": "Representative signature date",
    "Sign_consent": "Document consent",
    "Sign_consent_text": "I confirm that I have read this document and agree with its contents as described.",
    "Signed_by_employee": "Sign on behalf of Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Signing on behalf of client",
    "User": "User"
  },
  "File_tree": {
    "Copy": "Copy",
    "Copy category": "Copy folder",
    "Copy category item fail": "Folder could not be copied.",
    "Copy category item success": "Folder copied successfully.",
    "Copy document": "Copy document",
    "Copy document item fail": "Document could not be copied.",
    "Copy document item success": "Document copied successfully.",
    "Copy or move item": "Copy/move",
    "Delete": "Remove",
    "Delete document item": "Delete File",
    "Delete document item fail": "Error deleting file.",
    "Delete document item success": "File deleted successfully.",
    "Delete document item text": "Are you sure you don {0} want to {1}the file ?",
    "Delete category item": "Delete folder",
    "Delete category item fail": "The folder could not be deleted. ",
    "Delete category item success": "Folder deleted successfully.",
    "Delete category item text": "{2}Are you sure you want to {1}the folder {0} ?",
    "Deletion of data recursive": "All underlying folders and files will also be deleted!",
    "Description": "Definition",
    "Edit document item": "Edit file",
    "Edit document item fail": "Error editing file.",
    "Edit document item success": "File successfully modified.",
    "Edit category item": "Edit folder",
    "Edit category item fail": "The folder could not be changed. ",
    "Edit category item success": "Folder successfully modified.",
    "Error loading data": "The files could not be loaded.",
    "Errors": {
      "CATEGORY_ALREADY_EXISTS": "The folder already exists in this location.",
      "CATEGORY_CANNOT_BE_ITS_OWN_DECENDANT": "A folder cannot be moved into one of its own subfolders.",
      "COPY_CATEGORIES_FORBIDDEN_DESTINATION": "You do not have the required permissions to perform this action.",
      "COPY_FILES_FORBIDDEN_DESTINATION": "You do not have the required permissions to perform this action.",
      "FILE_OVERWRITE_REQUIRED": "Files with the same name already exist in the destination folder. Enable overwrite to proceed with this action.",
      "MOVE_CATEGORIES_FORBIDDEN_DESTINATION": "You do not have the required permissions to perform this action.",
      "MOVE_CATEGORIES_FORBIDDEN_SOURCE": "You do not have the required permissions to perform this action.",
      "MOVE_FILES_FORBIDDEN_DESTINATION": "You do not have the required permissions to perform this action.",
      "MOVE_FILES_FORBIDDEN_SOURCE": "You do not have the required permissions to perform this action."
    },
    "File": "File",
    "File_tree": "Target location",
    "Files from client": "Files from client: {related}",
    "Files from location": "Files from location: {related}",
    "Move": "Move",
    "Move category": "Move folder",
    "Move category item fail": "Folder could not be moved.",
    "Move category item success": "Folder moved successfully.",
    "Move document": "Move document",
    "Move document item fail": "Document could not be moved.",
    "Move document item success": "Document moved successfully.",
    "Name": "Name",
    "New document item": "Add new file",
    "New document item fail": "Error adding the file.",
    "New document item success": "New file successfully added.",
    "New category item": "New Folder",
    "New category item fail": "Error adding the folder.",
    "New category item success": "New folder successfully created.",
    "No file trees available": "No locations available to @.lower:{action} to.",
    "Nothing to show": "No results found.",
    "Original_filename": "Original file name",
    "Overwrite existing": "Overwrite existing files with the same filename",
    "Parent folder": "Parent folder",
    "Preview file item": "Preview",
    "Show list view": "List View",
    "Show tree view": "Tree view",
    "Unauthorized": "Insufficient permissions"
  },
  "Fobo": {
    "Added by": "Added By",
    "Aggression_nature": "Nature of aggression",
    "Aggression_to": "Aggression towards",
    "Attachment": "Attachment",
    "Attachment_signoff": "Sign-off list",
    "Cause": "Cause",
    "Client": "Client",
    "Client name": "Client name",
    "Created": "Created at",
    "Date": "Date",
    "Date_from": "Date (from)",
    "Date_until": "Date (up to)",
    "Delete item": "Delete Report",
    "Delete item fail": "Error deleting the report.",
    "Delete item success": "Report successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the {0}?",
    "Dialog confirm report finalization": {
      "Message": "Are you sure you want to mark this FOBO report as final?",
      "Title": "Confirm final marking FOBO report"
    },
    "Edit item": "Edit report",
    "Edit item fail": "Error when changing the report.",
    "Edit item success": "Report successfully amended.",
    "Editable_by": "Editable by",
    "Error loading data": "The FOBO reports list could not be loaded",
    "Export item": "Export",
    "Export item fail": "There was an error exporting the reports.",
    "Export item success": "Successfully exported reports.",
    "Falling": "Falling",
    "Finalized": "Finalized",
    "Involved": "Involved",
    "Location": "Location",
    "Medication": "Medications/fluid name",
    "Name": "Name",
    "Nature_of_incident": "Nature of incident",
    "New item": "New report",
    "New item fail": "Error when creating the report.",
    "New item success": "Report successfully added.",
    "Other": "Other",
    "Recommendation": "Advice on long-term measures",
    "Remediation": "Immediate action or measure taken",
    "Report finalized": "This form has been finalized, changes are no longer possible.",
    "Time": "Time",
    "Undesired_behaviour": "Undesirable behaviour",
    "Walk_away": "Walk away",
    "Where": "Scene of the event"
  },
  "Food": {
    "Added by": "Added By",
    "Bread_amount": "Number of sandwiches",
    "Client": "Client",
    "Client name": "Client name",
    "Created": "Created at",
    "Date": "Date",
    "Delete item": "Delete Report",
    "Delete item fail": "Error deleting the report.",
    "Delete item success": "Report successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the {0}?",
    "Edit item": "Edit report",
    "Edit item fail": "Error changing the report. Report not changed.",
    "Edit item success": "Report successfully modified.",
    "Editable_by": "Editable by",
    "Food": "Food",
    "Food_full": "What was eaten?",
    "Name": "Name",
    "New item": "New report",
    "New item fail": "Error creating the new report.",
    "New item success": "Report added successfully.",
    "Notes": "Notes",
    "Number_of_drinks": "Number of drinks",
    "ObjectName": "Food report | Food reports",
    "Shift": "Shift",
    "Time": "Time"
  },
  "General_practitioner": {
    "Address": "Address",
    "City": "City",
    "Delete": "Delete",
    "Delete item": "Remove general practitioner",
    "Delete item fail": "Error removing the general practitioner.",
    "Delete item success": "General practitioner successfully removed.",
    "Delete item text": "Are you sure you want to {1} the general practitioner {0}?",
    "Edit item": "Edit general practitioner",
    "Edit item fail": "Error editing the general practitioner.",
    "Edit item success": "General practitioner successfully edited.",
    "Email": "Email address",
    "Error loading data": "The list of general practitioners could not be loaded",
    "Full_name": "Full name",
    "House_annex": "Annex",
    "House_number": "House number",
    "New item": "New general practitioner",
    "New item fail": "Error in creating a new general practitioner.",
    "New item success": "New general practitioner successfully created.",
    "Phone_alternative": "Alternative phone number",
    "Phone_primary": "Primary phone number",
    "Postal_code": "Postal code"
  },
  "Globals": {
    "Add photo": "Add photo",
    "Admin": "Admin",
    "Aid-objects": "Aid objects",
    "All": "All | Everything",
    "And": " and ",
    "And another": "And {count} more...",
    "Archive item": "Archive | Archive @:{item}",
    "Assigned": "Assigned",
    "At": "at",
    "Attention": "Caution",
    "Awaits": "Wait for",
    "Back": "Back",
    "Back to": "Back to @.lower:{to}",
    "Back to previous page": "Back to the previous page",
    "Behavior": "Behavior",
    "Behaviour": "Behavior",
    "Biometrics": {
      "Biometrics activated successfully": "Touch/Face ID has been activated successfully.",
      "Biometrics activation failed": "Touch/Face ID setup failed.",
      "ECD app locked": {
        "Message": "You have touch ID or face ID turned on. Confirm your identity to unlock the app.",
        "Title": "ECD app locked"
      },
      "Setup biometrics": {
        "Message": "Your phone has Touch ID or Face ID turned on. Do you want to use this to unlock the app?<br />When Touch ID or Face ID is not enabled, the app will automatically log out after 15 minutes of inactivity.",
        "Title": "How to enable Touch ID / Face ID?"
      },
      "Unlock ECD app": {
        "cancelButtonTitle": "Annul",
        "description": "Use Touch ID or Face ID",
        "Title": "Unlock ECD"
      }
    },
    "Birthday": "{name} 's birthday today!",
    "Camera error": "The camera cannot be loaded.",
    "Cancel": "Cancel",
    "Cancel item fail": "Cancel failed",
    "Cancel item success": "Cancellation was successful",
    "Change": "Change",
    "Changed": "@:{key} customized",
    "Choose photo": "Choose a photo",
    "Clear recording": "Clear recording",
    "Click to copy ID": "Click on the icon to copy the ID",
    "Click to open image": "Click to open the image",
    "Click to open PDF": "Click to open the PDF",
    "Client": "Client | Clients",
    "Client-admin": "Clients",
    "Clients": "Clients",
    "Clone item": "Duplicate @.lower:{item}",
    "Close": "Close",
    "Collapse menu": "Collapse menu",
    "Contacts": "Contacts",
    "Copy fail": "Unable to copy text to clipboard.",
    "Copy item": "Copy @.lower:{item}",
    "Copy success": "Text copied to the clipboard.",
    "Countries": {
      "ABW": "ARUBA",
      "AFG": "Afghanistan",
      "AGO": "ANGOLA",
      "AIA": "ANGUILLA",
      "ALA": "Åland Islands",
      "ALB": "Albania",
      "AND": "Andorra",
      "ARE": "United Arab Emirates",
      "ARG": "Argentina",
      "ARM": "Armenia",
      "ASM": "American Samoa",
      "ATA": "Antarctica",
      "ATF": "French Southern Territories (de)",
      "ATG": "ANTIGUA AND BARBUDA",
      "AUS": "Australia",
      "AUT": "Austria",
      "AZE": "Azerbaijan",
      "BDI": "BURUNDI",
      "BEL": "Belgium",
      "BEN": "BENIN",
      "BES": "Bonaire, St. Eustatius and Saba",
      "BFA": "BURKINA FASO",
      "BGD": "BANGLADESH",
      "BGR": "Bulgaria",
      "BHR": "BAHRAIN",
      "BHS": "BAHAMAS",
      "BIH": "Bosnia and Herzegovina",
      "BLM": "Saint Barthélemy",
      "BLR": "Belarus",
      "BLZ": "BELIZE",
      "BMU": "BERMUDA",
      "BOL": "Bolivia (plurinational state)",
      "BRA": "Brazil",
      "BRB": "BARBADOS",
      "BRN": "Brunei Darussalam",
      "BTN": "BHUTAN",
      "BVT": "Bouvet Island",
      "BWA": "BOTSWANA",
      "CAF": "Central African Republic (de)",
      "CAN": "Canada",
      "CCK": "Cocos (Keeling) Islands (de)",
      "CHE": "Switzerland",
      "CHL": "Chile",
      "CHN": "CHINA",
      "CIV": "IVORY COAST",
      "CMR": "CAMEROON",
      "COD": "Democratic Republic of the Congo",
      "COG": "Congo",
      "COK": "COOK ISLANDS",
      "COL": "Colombia",
      "COM": "Comoros",
      "CPV": "Cabo Verde",
      "CRI": "Costa Rica",
      "CUB": "Cuba",
      "CUW": "CURACAO",
      "CXR": "Christmas Island",
      "CYM": "Cayman Islands",
      "CYP": "Cyprus",
      "CZE": "Czech Republic",
      "DEU": "Germany",
      "DJI": "DJIBOUTI",
      "DMA": "DOMINICA",
      "DNK": "Denmark",
      "DOM": "Dominican Republic (de)",
      "DZA": "ALGERIA",
      "ECU": "Ecuador",
      "EGY": "Egypt",
      "ERI": "Eritrea",
      "ESH": "Western Sahara",
      "ESP": "Spain",
      "EST": "Estonia",
      "ETH": "Ethiopia",
      "FIN": "Finland",
      "FJI": "FIJI",
      "FLK": "Falkland Islands [Malvinas]",
      "FRA": "France",
      "FRO": "Faroe Islands",
      "FSM": "Micronesia (Federated States of)",
      "GAB": "GABON",
      "GBR": "United Kingdom of Great Britain and Northern Ireland (de)",
      "GEO": "GEORGIA",
      "GGY": "GUERNSEY",
      "GHA": "GHANA",
      "GIB": "GIBRALTAR",
      "GIN": "GUINEA",
      "GLP": "Guadeloupe",
      "GMB": "The Gambia",
      "GNB": "GUINEA-BISSAU",
      "GNQ": "EQUATORIAL GUINEA",
      "GRC": "Greece",
      "GRD": "GRENADA",
      "GRL": "GREENLAND",
      "GTM": "GUATEMALA",
      "GUF": "French Guiana",
      "GUM": "Guam",
      "GUY": "Guyana",
      "HKG": "Hongkong",
      "HMD": "Heard and McDonald Islands",
      "HND": "HONDURAS",
      "HRV": "Croatia",
      "HTI": "Haiti",
      "HUN": "Hungary",
      "IDN": "Indonesia",
      "IMN": "Isle of Man",
      "IND": "INDIA",
      "IOT": "British Indian Ocean Territory (de)",
      "IRL": "Ireland",
      "IRN": "Iran (Islamic Republic)",
      "IRQ": "IRAQ",
      "ISL": "ICELAND",
      "ISR": "ISRAEL",
      "ITA": "Italy",
      "JAM": "JAMAICA",
      "JEY": "JERSEY",
      "JOR": "JORDAN",
      "JPN": "Japan",
      "KAZ": "Kazakhstan",
      "KEN": "Kenya",
      "KGZ": "Kyrgyzstan",
      "KHM": "Cambodia",
      "KIR": "KIRIBATI",
      "KNA": "SAINT KITTS AND NEVIS",
      "KOR": "Korea (Republic of)",
      "KWT": "KUWAIT",
      "LAO": "Lao People's Democratic Republic (de)",
      "LBN": "Lebanon",
      "LBR": "Liberia",
      "LBY": "LIBYA",
      "LCA": "SAINT LUCIA",
      "LIE": "LIECHTENSTEIN",
      "LKA": "SRI LANKA",
      "LSO": "LESOTHO",
      "LTU": "Lithuania",
      "LUX": "Luxembourg",
      "LVA": "Latvia",
      "MAC": "Macao",
      "MAF": "Saint Martin (French part)",
      "MAR": "Morocco",
      "MCO": "Monaco",
      "MDA": "Moldova (the Republic)",
      "MDG": "Madagascar",
      "MDV": "MALDIVES",
      "MEX": "Mexico",
      "MHL": "MARSHALL ISLANDS",
      "MKD": "Republic of North Macedonia",
      "MLI": "MALI",
      "MLT": "Malta",
      "MMR": "Myanmar",
      "MNE": "MONTENEGRO",
      "MNG": "Mongolia",
      "MNP": "Northern Mariana Islands (de)",
      "MOZ": "MOZAMBIQUE",
      "MRT": "Mauritania",
      "MSR": "MONTSERRAT",
      "MTQ": "MARTINIQUE",
      "MUS": "Mauritius",
      "MWI": "MALAWI",
      "MYS": "Malaysia",
      "MYT": "MAYOTTE",
      "NAM": "Namibia",
      "NCL": "New Caledonia",
      "NER": "NIGER",
      "NFK": "Norfolk Island",
      "NGA": "NIGERIA",
      "NIC": "Nicaragua",
      "NIU": "NIUE",
      "NLD": "Netherlands",
      "NOR": "Norway",
      "NPL": "Nepal",
      "NRU": "NAURU",
      "NZL": "NEW ZEALAND",
      "OMN": "Oman",
      "PAK": "PAKISTAN",
      "PAN": "PANAMA",
      "PCN": "PITCAIRN",
      "PER": "Peru",
      "PHL": "Philippines",
      "PLW": "PALAU",
      "PNG": "PAPUA NEW GUINEA",
      "POL": "Poland",
      "PRI": "Puerto Rico",
      "PRK": "Korea (the Democratic People's Republic)",
      "PRT": "Portugal",
      "PRY": "Paraguay",
      "PSE": "Palestine, State",
      "PYF": "French Polynesia",
      "QAT": "Qatar",
      "REU": "REUNION",
      "ROU": "Romania",
      "RUS": "Russian Federation (de)",
      "RWA": "Rwanda",
      "SAU": "Saudi Arabia",
      "SDN": "Sudan",
      "SEN": "Senegal",
      "SGP": "SINGAPORE",
      "SGS": "South Georgia and the South Sandwich Islands",
      "SHN": "Saint Helena, Ascension and Tristan da Cunha",
      "SJM": "Svalbard and Jan Mayen",
      "SLB": "SOLOMON ISLANDS",
      "SLE": "SIERRA LEONE",
      "SLV": "El Salvador",
      "SMR": "SAN MARINO",
      "SOM": "Somalia",
      "SPM": "Saint Pierre and Miquelon",
      "SRB": "SERBIA",
      "SSD": "SOUTH SUDAN",
      "STP": "São Tomé and Príncipe",
      "SUR": "Suriname",
      "SVK": "Slovakia",
      "SVN": "Slovenia",
      "SWE": "Sweden",
      "SWZ": "ESWATINI",
      "SXM": "Sint Maarten (Dutch part)",
      "SYC": "SEYCHELLES",
      "SYR": "Syrian Arab Republic",
      "TCA": "Turks and Caicos Islands (de)",
      "TCD": "CHAD",
      "TGO": "TOGO",
      "THA": "Thailand",
      "TJK": "Tajikistan",
      "TKL": "TOKELAU",
      "TKM": "Turkmenistan",
      "TLS": "Timor-Leste",
      "TON": "Tonga",
      "TTO": "Trinidad and Tobago",
      "TUN": "Tunisia",
      "TUR": "Turkey",
      "TUV": "Tuvalu",
      "TWN": "TAIWAN",
      "TZA": "Tanzania, United Republic of",
      "UGA": "UGANDA",
      "UKR": "Ukraine",
      "UMI": "Minor Outlying Islands of the United States (de)",
      "URY": "Uruguay",
      "USA": "United States of America (de)",
      "UZB": "Uzbekistan",
      "VAT": "Holy See (de)",
      "VCT": "SAINT VINCENT AND THE GRENADINES",
      "VEN": "Venezuela (Bolivarian Republic)",
      "VGB": "Virgin Islands (British)",
      "VIR": "Virgin Islands (USA)",
      "VNM": "Viet Nam",
      "VUT": "VANUATU",
      "WLF": "WALLIS AND FUTUNA",
      "WSM": "Samoa",
      "YEM": "YEMEN",
      "ZAF": "SOUTH AFRICA",
      "ZMB": "Zambia",
      "ZWE": "ZIMBABWE"
    },
    "Created": "Created",
    "Current": "Current",
    "Current time": "Current time",
    "Date": "Date",
    "Datepicker": {
      "Days": "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday",
      "DaysShort": "Su_Mo_Tu_We_Th_Fr_Sa",
      "Months": "January_February_March_April_May_June_Juli_August_September_October_November_December",
      "MonthsShort": "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec",
      "PluralDay": "Day"
    },
    "Day": "Day",
    "DaysOfWeek": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    "Delete": "remove",
    "Delete item": "Remove | Remove @.lower:{item}",
    "Delete item archive": "Archive {0}",
    "Delete item fail": "Error deleting @.lower:{item}.",
    "Delete item force delete": "{0} and forcibly delete all underlying data",
    "Delete item success": "@.capitalize:{item} successfully removed.",
    "Delete item text": "Are you sure you want to {1} object {0}?",
    "Delete item title": "Delete @.lower:{item} ",
    "Description": "Definition",
    "Deselect All": "Deselect all",
    "Dialog confirm copy profile": {
      "Message": "Are you sure you want to copy the <strong>{formType}</strong> form/protocol?",
      "Title": "Copy protocol/form"
    },
    "Dialog confirm copy profile supportplan": {
      "Message": "Are you sure you want to copy the <strong>support plan</strong>?",
      "Title": "Copy support plan"
    },
    "Dialog confirm copy profile wzd": {
      "Message": "Are you sure you want to copy the <strong>WZD registration</strong>?",
      "Title": "Copy WZD registration"
    },
    "Dialog confirm expire": {
      "Message": "Are you sure you want to cancel the protocol/consent form <strong>{formType}</strong> ?",
      "Title": "Expire Protocol/Consent Form"
    },
    "Dialog confirm expire supportplan": {
      "Message": "Are you sure you want to cancel the <strong>support plan</strong>?",
      "Title": "Cancel the support plan"
    },
    "Dialog confirm expire wzd": {
      "Message": "Are you sure you want to cancel the <strong>WZD registration</strong>?",
      "Title": "Cancel the support plan"
    },
    "Dialog confirm import roles": {
      "Message": "Are you sure you want to import the roles and overwrite the current roles?",
      "Title": "Import roles"
    },
    "Dialog confirm revert expire": {
      "Message": "Are you sure you want to undo the expiration of this <strong>{formType}</strong> ?",
      "Title": "Undo expired"
    },
    "Dialog confirm revert expire supportplan": {
      "Message": "Are you sure you want to undo the expiration of the <strong>support plan</strong>?",
      "Title": "Undo expired"
    },
    "Dialog confirm revert expire wzd": {
      "Message": "Are you sure you want to undo the expiration of the <strong>WZD-registratie</strong>?",
      "Title": "Undo expired"
    },
    "Dialog confirm revert status": {
      "Message": "Are you sure you want to cancel the signing phase and go back to the draft phase?",
      "Title": "Reverting to draft phase"
    },
    "Documentation": "Documentation",
    "Done": "Done",
    "Download": "Download | Download {type}",
    "Download fail": "File download failed.",
    "Download success": "File download successful.",
    "Edit item": "Edit | Edit @.lower:{item}",
    "Edit item fail": "Change failed",
    "Edit item success": "@.capitalize:{object} successfully modified",
    "Edited": "Edited",
    "Audit-log-admin": "Audit log management",
    "Audit-logs": "Audit logs",
    "Email-log-admin": "Email management",
    "Email-logs": "Email logs",
    "Empty": "NA",
    "Enter time": "Enter time",
    "Epilepsy": "Epilepsy",
    "Error": "Error",
    "Errors": {
      "404": "The requested page was not found.",
      "404 description": "Check the web address or return to a known page within the ECD.",
      "Data error": "There was a problem loading the data.",
      "Default": "@:{key} is a required field",
      "Delete item has dependencies": "The item has dependencies. Remove the dependencies first.",
      "Delete item has dependencies or archive": "The item has dependencies. Delete the dependencies first or archive the item.",
      "Delete item has dependencies or force delete": "The item has dependencies. Remove the dependencies first or choose Force Delete.",
      "Email in use": "The email address you entered is already in use. Log in with your old email address and try to change to an address that is not yet in use.",
      "Error loading data": "The list of {item} could not be loaded due to an error.",
      "Invalid": "@:{key} has an invalid value",
      "Invalid_date_in_future": "Date cannot be in the future.",
      "Item fail": "There was an error processing your request, please try again.",
      "Loading app": "The ECD could not be loaded. \n\nPlease check your internet connection or try again.",
      "Max_length": "@:{key} is too long.",
      "Min_length": "@:{key} is too short.",
      "No options available": "No options Available",
      "Open URL warning": "Unable to download invoice. Allow pop-ups for OMNI Vision to enable invoice downloads.",
      "Permission denied": "Oops! It looks like you don't have permission to access this resource. If you think this is a mistake, please contact support or try again later.",
      "Technical issue": "The requested action cannot be completed right now.",
      "Technical issue description": "Due to a technical issue, the required data cannot be loaded at the moment. Go back to the previous page or return to the home page and try again later.",
      "Required": {
        "default": "@:{key} is a required field"
      },
      "Unauthorized": "Not allowed",
      "User not found": "The user {m}could not be retrieved from the server."
    },
    "Excrement": "@:Report.Excrement",
    "Expand menu": "Expand menu",
    "Expire item": "Mark as expired",
    "Expire item fail": "Error in letting it expire.",
    "Expire item success": "Successfully let it expire.",
    "Expired": "Expired",
    "Export": "Export",
    "Export item": "Export",
    "Export item fail": "Error processing export.",
    "Export item success": "Successfully exported.",
    "Failed": "Failed",
    "File": "File",
    "Files": "Files",
    "Filters": "Filters | Set filters",
    "Finalize": "Finalize",
    "Flush": "Flush",
    "Fobo": "@:Report.Fobo",
    "Folder": "Folder",
    "Food": "Food",
    "Fullscreen": "Full Screen | Exit full screen",
    "Future": "Future",
    "General-practitioners-admin": "General practitioners",
    "General-reports": "General reporting",
    "Go to overview": "Show overview",
    "Grid": "Grid",
    "Hide messages": "Hide messages",
    "Home": "Back to top",
    "Hours": "Hours | Hours",
    "Hrs": "Hours | Hours",
    "Https required": "HTTPS required",
    "Import": "Import",
    "Import item fail": "Error importing",
    "Import item success": "Successfully imported",
    "Invalid": "@:{key} is not valid",
    "Invalid date": "Invalid date: {format}.",
    "Invalid time": "Invalid time: {format}.",
    "Item action": "{action} {type}",
    "Item fail": "Action: {action}. <br />Service: {type}  <br />Purpose: {item}.  <br />Result: FAILED",
    "Item success": "Action: {action}. <br />Service: {type}  <br />Purpose: {item}.  <br />Result: SUCCESS",
    "Last 2 weeks": "Last 2 weeks",
    "Last 3 days": "Last 3 days",
    "Last 30 days": "Last 30 Days",
    "Last 90 days": "Last 90 days",
    "Last update": "Changed",
    "Last week": "Last week",
    "Legend": "Legend",
    "Legionella": "Legionella",
    "List": "List",
    "Loading": "ECD is loading, please wait...",
    "Location": "Locations",
    "Location-admin": "Locations",
    "Locations": "Locations",
    "Lock item fail": "Error in finalizing the report.",
    "Lock item success": "Report successfully marked as final.",
    "Logout": "Log out",
    "Main": "Main page",
    "MainPage": {
      "Clients": "Manage client data. Gain insight into files and relevant healthcare information.",
      "Locations": "Manage locations. Keep track of location-specific information and amenities.",
      "Management": "Manage all basic data about clients, employees, locations and more.",
      "Messages": "Manage the message traffic regarding care assignments and declarations.",
      "Profile": "View and manage your personal profile settings and preferences.",
      "Quality manual": "Clearly store and manage documents from the quality manual.",
      "Technical services": "Manage technical notifications and maintenance. Get instant visibility into status and progress.",
      "Transportation": "Clearly store and manage documents related to transport."
    },
    "Management": "Management",
    "ManagementMainPage": {
      "Audit logs": "Manage audit logs and request activity.",
      "Clients": "Manage clients and keep their data up to date within the system.",
      "Email logs": "Manage outgoing email logs and delivery status.",
      "General practitioners": "Manage GPs and keep their contact details up to date.",
      "Locations": "Manage locations within the organization and adjust address and location details.",
      "Representatives": "Manage representatives and keep up-to-date parent and contact information up to date.",
      "Roles": "Manage user roles and fine-tune access rights by function group.",
      "Users": "Manage employees and maintain their data, roles and availability."
    },
    "Mandatory": "@:{key} is required",
    "Max end date": "The maximum end date is: {maxEndDate}",
    "Max end dateTime": "The maximum end date/time is: {maxEndDate}",
    "Maximize": "Maximize",
    "Medical-file": "Medical file",
    "Memo": "Memos",
    "Menu": "Menu",
    "Message": "Message",
    "Messages": "Messages",
    "MessagesMainPage": {
      "Vecozo messages": "Communication about allocations and claims.",
      "Vektis-declaraties": "Manage and prepare claims.",
      "Vektis-prestatie-groups": "Manage Vektis performance groups.",
      "Vektis-prestaties": "Manage rates for Vektis performance codes.",
      "Vektis-uzovi": "Overview of the UZOVI register."
    },
    "Min start date": "The minimum start date is: {minStartDate}",
    "Min start dateTime": "The minimum start date/time is: {minStartDate}",
    "Mins": "Min | Minutes",
    "Minutes": "Minute | Minutes",
    "Month": "Month",
    "Months": "Months",
    "MonthsOfYear": {
      "1": "January",
      "2": "February",
      "3": "March",
      "4": "April",
      "5": "May",
      "6": "June",
      "7": "July",
      "8": "August",
      "9": "September",
      "10": "October",
      "11": "November",
      "12": "December"
    },
    "More options": "More options",
    "Move": "Move",
    "My profile": "My profile",
    "New item": "New | New @.lower:{item}",
    "New item fail": "Insert failed.",
    "New item success": "@.capitalize:{object} created successfully.",
    "New messages": "There are new messages.",
    "Next": "Next",
    "No": "No",
    "No data": "No data were found.",
    "No messages found": "No messages for this message board.",
    "No results": "There is no data, or no results match the filter",
    "None": "No",
    "Not": "Not",
    "Not allowed": "You are not authorized to view the requested page. If you think this is incorrect, please contact your administrator.",
    "Not applicable": "N/A",
    "Notifications": {
      "Automatic logout": "You will be automatically logged out in {secLeft} seconds. | You'll be automatically logged out in {secLeft} seconds."
    },
    "Of": "Of | of",
    "On": "on",
    "Open clock": "Open clock",
    "Options": "Options",
    "Page": "Page",
    "PartsOfDay": {
      "afternoon": "afternoon",
      "evening": "evening",
      "morning": "morning",
      "night": "night"
    },
    "Photo added successfully": "Photo added successfully.",
    "Please note": "Please note",
    "Please wait": "Please wait...",
    "Presence": "Presence",
    "Preview file item": "Preview",
    "Process": "Process",
    "Process item fail": "Processing failed.",
    "Process item success": "Processing carried out successfully.",
    "Processed": "Processed",
    "Processing recording": "Processing recording. One moment...",
    "Profile": "Profile",
    "Protocol or form not available": "Not filled in",
    "Protocols-and-forms": "Protocols and forms",
    "ProtocolsAndFormsStatusOptions": {
      "CANCELLED": "Canceled",
      "CONCEPT": "Concept",
      "EXPIRED": "Expired",
      "FINAL": "Final",
      "REPLACED": "Replaced",
      "SIGN_EMPLOYEE": "Signing (employee)",
      "SIGN_REPRESENTATIVE": "Signing (representative)",
      "SUPERSEDED": "Replaced"
    },
    "Quality-handbook": "Quality manual",
    "Quarter": "Quarter",
    "Record": "Record",
    "Record audio clip": "Record audio clip",
    "Recording": "Recording...",
    "Refresh": "Refresh",
    "Refresh list": "Refresh list",
    "Refresh messages": "Refresh messages",
    "Reload app": "Reload",
    "Reply to audio recording only": "Audio clip",
    "Report": "Report",
    "Reports": "Reports",
    "Representative": "Representatives",
    "Representative-admin": "Representatives",
    "Reset": "Reset",
    "Retry": "Try Again",
    "Revert item fail": "Error when reverting to the draft phase.",
    "Revert item success": "Successfully restored to the draft phase.",
    "Revert to concept": "Revert to draft",
    "Revert_expire item": "Undo expired",
    "Revert_expire item fail": "Error undoing the expiration",
    "Revert_expire item success": "Undo expired",
    "Roles": "Roll",
    "Roles-admin": "Roles",
    "Rows per page": "Rows per page | Amount",
    "Rows selected": "{count} of {total} {type} record(s) selected",
    "Save": "Save",
    "Select All": "Select All",
    "Select item from list": "Select the @.lower:{item} to display data.",
    "Select language": "Select a language",
    "Select regional settings": "Select a regional breakdown",
    "Selected items": "{selected} of {total} @.lower:{items} selected",
    "Settings": "Institutions",
    "Show": "Show",
    "Show messages": "Show messages",
    "Show more": "Show more",
    "Show only active": "Only show active items",
    "Show only archived": "Only show archived items",
    "Show or hide columns": "Columns to display",
    "Sign document": "Sign",
    "Sign employee": "Signing employee",
    "Sign on location": "Sign on location",
    "Sign representative": "Signing representative",
    "Signature": "Signature",
    "Signed by employee item fail": "Error signing for the employee. Signing was not successful.",
    "Signed by employee item success": "Signing by the employee successfully. The drawing phase has now been completed.",
    "Signed by representative item fail": "Error signing for the representative. Signing was not successful.",
    "Signed by representative item success": "Signing by the representative successfully.",
    "Signing upload attachment": "Upload the signed document. Make sure the document is signed by both the GP and the employee!",
    "Signing upload attachment item": "Upload signed document",
    "Sort": "Sort",
    "Sort data": "Sort data",
    "SortOptions": {
      "Ascending": "Ascending",
      "Descending": "Descending"
    },
    "Staff": "Staff",
    "Start recording": "Click \"Record ({0})\" to start recording",
    "Start signing": "Start signing phase",
    "Start signing form message": "Place your signature within the box below, and press \"Sign\" to sign the document.",
    "Start signing item fail": "Error when starting the signing phase.",
    "Start signing item success": "Signing phase successfully started",
    "Status": "Status",
    "Success": "Good luck",
    "Support-plans": "Support Plan | Support plans",
    "Switch to": "Switch to @.lower:{mode}view",
    "Table of contents": "Table of contents",
    "Take photo": "Take a picture",
    "Task": "Task",
    "Task-category": "Job category",
    "Task-template": "Task template",
    "Tasks": "Tasks",
    "Technical": "Technical",
    "Technical-services": "Technical service",
    "Technical-services-admin": "Maintenance",
    "Temperature": "@:Report.Temperature",
    "Today": "Today",
    "Transportation": "Transport",
    "Try again": "Try again",
    "Undo finalize": "Undo finalize",
    "Unknown": "Unknown",
    "Unsaved changes": "Changes have not yet been saved. Are you sure you want to leave the page and undo the changes?",
    "Unsaved changes title": "Unsaved changes",
    "Update available": "Update available. Reload to update.",
    "Upload file": "File Upload",
    "User": "Employee | Employees",
    "Users": "Employees",
    "Value": "Value",
    "Vecozo-messages": "Messagebox | Messaging",
    "VecozoMessages": "Vecozo messages",
    "Vektis-declaraties": "Declarations",
    "Vektis-prestatie-groups-admin": "Vektis performance groups",
    "Vektis-prestaties-admin": "Vektis Performance Codes",
    "Vektis-uzovi-admin": "UZOVI Register",
    "View item": "Open @.lower:{item}",
    "Week": "Week",
    "Weeks": "Weeks",
    "Weight": "@:Report.Weight",
    "Windowed": "Floating",
    "Wzd": "Care and Compulsion act | Care and Compulsion acts",
    "Year": "Year",
    "Yes": "Yes"
  },
  "Gp_execution_request_form": {
    "Answer": "Permission:",
    "Answer_false": "The implementation request cannot be accepted by Nocht en Wille Zorg",
    "Answer_representative": "The implementation request can be accepted by Nocht en Wille Zorg",
    "Answer_true": "The implementation request can be accepted by Nocht en Wille Zorg",
    "Attachment": "Attachment",
    "Cancelled": "Expired",
    "Client": "Client",
    "Complications": "Any patient-related complications/side effects",
    "Complications_representative": "Any patient-related complications/adverse events (representative)",
    "Delete item": "Removal of a GP's implementation request",
    "Delete item fail": "Error in removing GP execution request.",
    "Delete item success": "Execution request GP successfully removed.",
    "Delete item text": "Are you sure you want to {1} the implementation request to the general practitioner?",
    "Deleted": "Deleted",
    "Document is cancelled": "The document has expired.",
    "Document is expired": "Please note: the validity of the document has expired!",
    "Document is final": "The document has been finalized and can no longer be changed.",
    "Documents awaits signing by representative": "The document is pending signature of the representative and can no longer be changed.",
    "Documents awaits signing by supplier": "The document is pending signature by Nocht and Wille and can no longer be changed.",
    "Dosage": "Exact dosage at a time",
    "Dosage_representative": "Exact dosage at a time (representative)",
    "Edit item": "Edit GP execution request",
    "Edit item fail": "Error editing the GP execution request.",
    "Edit item success": "Implementation request GP successfully edited.",
    "Editable_by": "Editable by",
    "Employee": "Represented by",
    "Employee_signature": "Employee signature",
    "Employee_signature_date": "Employee signature date",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REPRESENTATIVE_SIGN_CONSENT": "You must give your consent before you can sign the document."
    },
    "Explanation": "Implementation request for medical treatment from individual general practitioner to the nurse/carer regarding a specific client.",
    "Form client address": "Address",
    "Form client birthdate": "Date of birth",
    "Form client BSN": "BSN",
    "Form client name": "Name",
    "Form doctor address": "Practice address",
    "Form doctor city": "City",
    "Form doctor name": "Name",
    "Form doctor phone number": "Telephone number",
    "Form_valid_until": "Valid until",
    "GP header": "The patient's GP (or his or her substitute)",
    "Gp_request_date": "Date",
    "Indication": "Indication/reason",
    "Indication_representative": "Indication/reason (representative)",
    "Medical_action": "Name of medical procedure",
    "Medical_action_representative": "Name of medical procedure (representative)",
    "Medication": "Medications/liquid; name",
    "Medication_representative": "Medications/liquid; Name (representative)",
    "New item": "Execution request GP",
    "New item fail": "Error when creating a new GP execution request.",
    "New item success": "New GP execution request successfully created.",
    "Only editable by representative": "The document can currently only be changed by representatives.",
    "Only editable by supplier": "The document can currently only be changed by Nocht and Wille.",
    "Other_relevant_details": "Other information considered relevant in this context",
    "Other_relevant_details_representative": "Other information considered relevant in this context (representative)",
    "Reason_rejection": "Reason for rejection",
    "Reason_rejection_representative": "Reason for rejection (representative)",
    "Replaced_by": "Replaced_by",
    "Representative_signature": "Representative signature",
    "Representative_signature_date": "Representative signature date",
    "Request text": "To perform the medical procedure below for the benefit of the client in the context of the 'Framework Agreement for Medical Treatment' concluded for this purpose (in accordance with the protocols drawn up for this purpose).",
    "Requests": "Requests Nocht en Wille Zorg",
    "Sign_consent": "Document consent",
    "Sign_consent_text": "I confirm that I have read this document and agree with its contents as described.",
    "Signed_by_employee": "Sign on behalf of Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Signing on behalf of client",
    "Signing upload attachment item": "Upload signed execution request",
    "Specification_medical_action": "Further specification of the act",
    "Specification_medical_action_representative": "Further specification of the act (representative)",
    "Time_execution": "Timings of execution",
    "Time_execution_representative": "Timings of execution (representative)",
    "To be filled by doctor": "Further details (to be filled in by the doctor)",
    "User": "User"
  },
  "Languages": {
    "Dutch": "Dutch",
    "English": "English"
  },
  "Location": {
    "Address": "Address",
    "Attendant": "Accompanist",
    "Birthday": "Birthday",
    "Bsn_number": "Social Security numbers",
    "Care_types": "Care provided",
    "City": "City",
    "Date_of_birth": "Date of Birth",
    "Daycare": "Daycare",
    "Delete item": "Delete client",
    "Delete item fail": "Error deleting the client.",
    "Delete item success": "Location successfully removed.",
    "Delete item text": "Are you sure you want to {1} location {0}?",
    "Documentation": "Documentation",
    "Edit item": "Edit Client",
    "Edit item fail": "Error editing the client. Client not changed.",
    "Edit item success": "Location successfully changed.",
    "Edit photo": "Change Photo",
    "First_name": "First Name",
    "Flush reports": "Flushing list | Flushing lists",
    "FOBO reports": "FOBO notifications",
    "Gender": "Gender",
    "GenderOptions": {
      "M": "Husband",
      "O": "Unknown / Not Specified",
      "V": "Wife"
    },
    "General reports": "General reporting",
    "General_practitioner": "Doctor",
    "House_annex": "Addition",
    "House_number": "House number",
    "ID": "Id",
    "Indication": "Indication",
    "Insurance": "Insurance",
    "Insurance_number": "Insurance number",
    "Last_name": "Surname",
    "Legionella": "Legionella",
    "Legionella reports": "Legionella reports",
    "Living": "Live",
    "Locations": "Locations",
    "Memos": "Memos",
    "Menu item description": "{item} for {location}",
    "Name": "Name",
    "New item": "New client",
    "New item fail": "Error creating the new client.",
    "New item success": "Location successfully added.",
    "No available actions": "There are no available actions for this location.",
    "ObjectName": "Customer",
    "Photo": "Photograph",
    "Postal_code": "Zip code",
    "Presence reports": "Attendance registration | Attendance registrations",
    "Representatives": "Representatives",
    "Requires_legionella_temperature_check": "Legionella temperature control needed",
    "Stay": "Stay",
    "Tabs": {
      "Client care": "Care on location",
      "Employee roles": "Employee roles",
      "General": "General",
      "Tap points": "Taps",
      "Task categories": "To-do lists",
      "Task templates": "Task templates"
    },
    "Tap points": "Tap points",
    "Task categories": "To-do lists",
    "Tasks": "To-do list",
    "Technical-services": "Maintenance",
    "Telephone_number": "Telephone number",
    "Temperature check": "Temperature Control",
    "Transportation": "Transportation",
    "View location": "View location"
  },
  "Location_appointment": {
    "Alarm": "Alarm",
    "Alarm expired": "The specified time for the alarm has expired",
    "Appointment": "Appointment",
    "Appointments": "Appointments",
    "Datetime_end": "Time (end)",
    "Datetime_start": "Time (start)",
    "Delete item": "Delete appointment",
    "Delete item fail": "Error deleting the appointment.",
    "Delete item success": "Appointment successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the {0}?",
    "Edit item": "Edit appointment",
    "Edit item fail": "Error editing the appointment.",
    "Edit item success": "Appointment successfully edited.",
    "Message": "Appointment",
    "New item": "New appointment",
    "New item fail": "Error creating the appointment.",
    "New item success": "Appointment successfully created.",
    "User": "User"
  },
  "Location_flush_report": {
    "Delete item": "Delete report",
    "Delete item fail": "Error deleting the report.",
    "Delete item success": "Report successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the report {0}?",
    "Dialog confirm flush report finalization": {
      "Message": "Are you sure you want to mark this flush report as final?",
      "Title": "Confirm final marking spool report"
    },
    "Edit item": "Edit report",
    "Edit item fail": "Error changing the report.",
    "Edit item success": "Report successfully modified.",
    "Errors": {
      "CONFIRM_FLUSH": "Confirm flush",
      "DUPLICATE_YEAR_WEEK_COMBINATION": "Check the year/week combination",
      "ERROR_CONFIRM_FLUSH": "Confirm flush",
      "Invalid": "The entry is invalid",
      "REPORT_CANNOT_BE_IN_FUTURE": "The chosen combination for week and year must not be in the future",
      "Unique": "A report has already been made for this location for the chosen week"
    },
    "Export item": "Export",
    "Export item fail": "Error exporting the flush report.",
    "Export item success": "Flush report successfully exported.",
    "Finalize": "Finalize",
    "Finalized": "Finalized",
    "Finalized item": "This report has been permanently marked and cannot be changed.",
    "Finalized_by": "Finalized by",
    "Flushed_cold": "Cold",
    "Flushed_warm": "Warm",
    "Location": "Location",
    "Lock item fail": "Error in finalizing the report.",
    "Lock item success": "Report successfully marked as final.",
    "Name": "Name",
    "New item": "New report",
    "New item fail": "Error creating the report.",
    "New item success": "Report added successfully.",
    "ObjectName": "Flush report",
    "Tap_point": "Tap point",
    "Week": "Week",
    "Week_from": "Week (from)",
    "Week_until": "Week (up to)",
    "Year": "Year"
  },
  "Location_memo": {
    "By": "By",
    "Created": "Added on",
    "Delete item": "Delete memo",
    "Delete item fail": "Error deleting the memo.",
    "Delete item success": "Memo successfully removed.",
    "Delete item text": "Are you sure you want to {1} the memo {0}?",
    "Edit item": "Edit memo",
    "Memo": "Memo | Memos",
    "New item": "New memo",
    "ObjectName": "Memo",
    "Subject": "Subject",
    "Title": "Title",
    "User": "User"
  },
  "Location_presence": {
    "Active clients only": "Export non-archived clients only",
    "Choose an performance or group": "First, choose an achievement or group.",
    "Choose part of the day": "Choose a part of the day.",
    "Client": "Client",
    "Clients no longer linked to location": "The following clients are no longer linked to this location on this weekday, but already had an attendance registration: {list}",
    "Clients presence": "Clients present",
    "Clients with registrations elsewhere": "The following clients already have attendance registration at another location and cannot be chosen: {list}",
    "Date": "Date",
    "Edit item locked": "Registration is locked; You can't save changes.",
    "Export item": "Export attendance registration",
    "Export item fail": "Error when exporting the attendance records.",
    "Export item success": "Attendance records successfully exported.",
    "Generate presence list first": "First, generate the attendance list.",
    "Historical registrations editable": "The schedule has since changed for {list}. Existing attendance registrations remain visible and can still be corrected.",
    "Location": "Location",
    "Lock item fail": "No permission to lock.",
    "Month": "Month",
    "New item fail": "Attendance registration NOT saved.",
    "Non-declarable registrations": "Attendance registrations outside active care exist for {list} on {date}. They are not shown in the attendance list or automatically included in new declarations. Where permitted, historical care can be corrected through the declaration selection.",
    "No performances available": "No care has been provided at this location on the chosen date.",
    "Open registrations": "Registrations not finalized",
    "Open registrations found": " There are attendance registrations within the declaration period that have {not} yet been finalised. Only when \"Always declare\" is enabled for this type of care, a claim will be made regardless of the attendance registrations.",
    "Registration locked": "This attendance registration has been finalized and can only be changed by the location coordinator!",
    "Registrations": "Registrations",
    "Not all registration locked": "<strong>WARNING!</strong> Clients have been added after finalization. Use <strong>Undo Finalization</strong> to process them again and then finalize once more.",
    "Save item success": "Attendance registration saved.",
    "Type": "Format",
    "Vektisprestatie": "Service",
    "Year": "Year"
  },
  "Location_tap_point": {
    "Delete item": "Remove tap point",
    "Delete item fail": "Error removing the tap point.",
    "Delete item success": "Tap point successfully removed",
    "Delete item text": "Are you sure you want to {1} tap {0}?",
    "Edit item": "Edit tap point",
    "Edit item fail": "Error modifying the tap point.",
    "Edit item success": "Tap point successfully modified",
    "Location": "Location",
    "Name": "Name",
    "New item": "New tap point",
    "New item fail": "Error creating the tap point.",
    "New item success": "Tap point successfully created.",
    "ObjectName": "Tap point",
    "Type": "Type",
    "TypeOptions": {
      "COLD": "Cold water tap",
      "HOT": "Mixer tap"
    }
  },
  "Location_task_category": {
    "Delete item": "Delete task category",
    "Delete item fail": "Error deleting the task category.",
    "Delete item success": "Job category successfully deleted.",
    "Delete item text": "Are you sure you want to {1} task category {0}?",
    "Edit item": "Edit task category",
    "Location": "Location",
    "Name": "Name",
    "New item": "New category",
    "ObjectName": "Job category",
    "Tabs": {
      "General": "General",
      "Task templates": "Task templates"
    }
  },
  "Location_task_item": {
    "Category": "Category",
    "Deadline": "Deadline",
    "Deadline passed": "The deadline for this task has passed",
    "Delete item": "Delete task",
    "Delete item fail": "Error deleting the task.",
    "Delete item success": "Task successfully deleted.",
    "Delete item text": "Are you sure you want to {1} this task?",
    "Dialog confirm task completion": {
      "Message": "Are you sure you want to mark this task as complete?",
      "Title": "Confirm finish task"
    },
    "Edit item": "Edit task",
    "Edit item fail": "Error changing the task.",
    "Edit item success": "Task successfully modified.",
    "Finalize": "Finalize",
    "Finalized": "Finalized",
    "Finalized_by": "Finalized by",
    "Name": "Name",
    "New item": "New Task",
    "New item fail": "Error creating the task.",
    "New item success": "Task successfully added.",
    "Start": "Start",
    "Status": "Status",
    "StatusOptions": {
      "Finalized": "Finalized",
      "Todo": "To be carried out"
    },
    "Task marked as finalized": "Task marked as complete.",
    "Task marked as finalized failed": "The task could not be marked as completed.",
    "Template": "Template",
    "Template__category": "Category",
    "Template__category__location": "Location",
    "Template__description": "Task description",
    "View item": "View task"
  },
  "Location_task_template": {
    "Category": "Job category",
    "Deadline": "Deadline",
    "Deadline append": "weeks",
    "Delete item": "Delete task template",
    "Delete item fail": "Error deleting the task template.",
    "Delete item success": "Task template successfully deleted.",
    "Delete item text": "Are you sure you want to {1} task template {0}?",
    "Description": "Task description",
    "Edit item": "Update task template",
    "Edit item fail": "Error when changing the task template.",
    "Edit item success": "Task template successfully modified.",
    "Enabled": "Enabled",
    "Interval": "Interval",
    "Interval_type": "Interval type",
    "IntervalOptions": {
      "MONTHS": "month | months",
      "WEEKS": "week | weeks"
    },
    "Location": "Location",
    "Name": "Name",
    "New item": "New task template",
    "New item fail": "Error creating the task template.",
    "New item success": "New task template successfully added.",
    "ObjectName": "Task template"
  },
  "Location_temperature_report": {
    "Cold water": "Cold water",
    "Cold water text": "Turn on the tap and make sure that a jet as thick as a marker comes out of the tap. Measure the temperature halfway through the jet. Count to 10 and write down the initial value, count to 60 and measure the final value and write it down in the form.",
    "Delete item": "Delete Report",
    "Delete item fail": "Error deleting the report.",
    "Delete item success": "Report successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the report {0}?",
    "Dialog confirm temperature report finalization": {
      "Message": "Are you sure you want to mark this temperature report as complete?",
      "Title": "Confirm finalizing temperature report"
    },
    "Edit item": "Edit report",
    "Edit item fail": "Error changing the report.",
    "Edit item success": "Report successfully modified.",
    "Errors": {
      "DUPLICATE_YEAR_WEEK_COMBINATION": "Check the year/week combination",
      "INVALID_TEMPERATURE": "Temperature for @.lower:{key} is invalid.",
      "Max_value": "@:{key} should not be more than 100 degrees",
      "Max_whole_digits": "@:{key} can't be more than 3 digits",
      "Min_value": "@:{key} should not be less than 0 degrees",
      "Unique": "A report has already been made for this location for the chosen week"
    },
    "Export item": "Export",
    "Export item fail": "Error exporting the temperature report.",
    "Export item success": "Temperature report successfully exported.",
    "Finalize": "Finalize",
    "Finalized": "Finalized",
    "Finalized item": "This report has been permanently marked and cannot be changed.",
    "Finalized_by": "Finalized by",
    "Location": "Location",
    "Lock item fail": "Error in finalizing the report.",
    "Lock item success": "Report successfully marked as final.",
    "Name": "Name",
    "New item": "New report",
    "New item fail": "Error creating the report.",
    "New item success": "Report added successfully.",
    "Note": "Always measure COLD first and then WARM per tap!",
    "ObjectName": "Temperature report | Temperature reports",
    "Tap_point": "Tap point",
    "Temperature_cold_end": "Cold (end)",
    "Temperature_cold_start": "Cold (begin)",
    "Temperature_warm": "Warm",
    "Warm water": "Hot water",
    "Warm water text": "Turn on the tap and make sure there is a stream as thick as a marker coming out of the tap. Measure the temperature halfway through the jet. Wait 60 seconds, note the final temperature in the form.",
    "Week": "Week",
    "Week_from": "Week (from)",
    "Week_until": "Week (up to)",
    "Year": "Year"
  },
  "Location_user_role": {
    "Delete item": "Delete role assignment",
    "Delete item fail": "Error deleting the role assignment.",
    "Delete item success": "Role assignment successfully removed.",
    "Delete item text": "Are you sure you want to {1}the role assignment?",
    "Edit item": "Edit role assignment",
    "Edit item fail": "Error changing the role assignment.",
    "Edit item success": "Role assignment successfully changed.",
    "Error loading data": "The list of role assignments could not be loaded.",
    "Location": "Location",
    "New item": "New role assignment",
    "New item fail": "Error creating the role assignment.",
    "New item success": "Role assignment successfully added.",
    "Role": "Role",
    "User": "Employee"
  },
  "Location_workorder": {
    "Closed": "Closed on",
    "Created": "Created at",
    "Date_from": "Date (from)",
    "Date_until": "Date (up to)",
    "Delete item": "Delete work order",
    "Delete item fail": "Error deleting the work order.",
    "Delete item success": "Work order successfully deleted.",
    "Delete item text": "Are you sure you want to {1} work assignment {0}?",
    "Edit item": "Update work order",
    "Edit item fail": "Error updating the work order.",
    "Edit item success": "Work order successfully modified.",
    "Export item": "Export work orders",
    "Export item fail": "Error when exporting the work orders.",
    "Export item success": "Work orders successfully exported.",
    "Finalize": "Finalize",
    "Finish item success": "Work order finished successfully.",
    "Fixer": "Practitioner",
    "Handle": "Process",
    "Handled work orders": "Completed work orders",
    "Location": "Location",
    "Locations": "Locations",
    "New item": "New work order",
    "New item fail": "Error creating the work order.",
    "New item success": "New work order successfully created.",
    "ObjectName": "Work assignment",
    "Order": "Order",
    "Priority": "Priority",
    "Problem": "Problem",
    "Reject": "Reject",
    "Reject item success": "Work order rejected successfully.",
    "Reporter": "Reporter",
    "Status": "Status",
    "Status_reason": "Notes",
    "StatusOptions": {
      "1": "Open",
      "2": "On hold",
      "3": "Rejected",
      "4": "Finished"
    },
    "Title": "Subject",
    "Unhandled work orders": "Open Work Orders",
    "View item": "View work order",
    "Work order": "Work order",
    "Work orders": "Work orders"
  },
  "Medical_file": {
    "Add Medicalfileinvolved_set item": "Add medic",
    "Anesthesia": "Narcosis",
    "Average_body_temp": "Average body temperature",
    "Avg_doctor_results": "AVG Doctor Visits and Outcomes/Reports",
    "Blood_samples": "Blood tests",
    "Cardiology": "Cardiology",
    "City": "City",
    "Client": "Client",
    "Created": "Created",
    "Delete item": "Delete medical file",
    "Delete item fail": "Error in deleting medical file.",
    "Delete item success": "Medical file successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the medical file {0}?",
    "Delete Medicalfileinvolved_set item": "Remove medic",
    "Discipline": "Discipline",
    "Edit item": "Edit medical file",
    "Edit item fail": "Error editing the medical file. The medical file has not changed.",
    "Edit item success": "Medical file successfully changed.",
    "Epilepsy": "Epilepsy diagnoses and examinations",
    "Gp_visits": "GP visits",
    "Hospital_admissions": "Hospital admissions",
    "Kno": "ENT",
    "Length": "Length",
    "Medical involved overview": "List of doctors",
    "Medicalfileinvolved_set": "Medic overview",
    "Modified": "Changed",
    "Neurology": "Neurology",
    "New item": "New medical file",
    "New item fail": "Error when adding the medical file.",
    "New item success": "Medical file successfully created.",
    "No medical file": "No medical file has been created for client {0}. Please use the \"{1}\" button to create a medical file.",
    "Orthopedics": "Orthopedics",
    "Others": "Remainder",
    "Personal_history": "Birth, history and diagnosis",
    "Phone_number": "Telephone",
    "Physiotherapy": "Physiotherapy",
    "Practitioner": "General practitioner",
    "Speech_therapy": "Speech therapy",
    "Tabs": {
      "General": "General",
      "Involved": "Medics involved"
    },
    "Teeth": "Teeth",
    "Vision": "Vision"
  },
  "Medical_file_involved": {
    "City": "City",
    "Delete": "Delete",
    "Delete item": "Delete doctor",
    "Delete item fail": "Failed to delete doctor.",
    "Delete item success": "Doctor deleted successfully.",
    "Delete item text": "Are you sure you want to {1} doctor {0}?",
    "Discipline": "Discipline",
    "Edit item": "Edit doctor",
    "Edit item fail": "Failed to edit doctor. Doctor was not edited.",
    "Edit item success": "Doctor edited successfully.",
    "New item": "New doctor",
    "New item fail": "Failed to add doctor.",
    "New item success": "Doctor added successfully.",
    "ObjectName": "Medicus | Medici",
    "Phone_number": "Telephone",
    "Practitioner": "General practitioner"
  },
  "Message_board_message": {
    "Delete": "remove",
    "Delete item": "Delete Message",
    "Delete item fail": "Error deleting the message.",
    "Delete item success": "The message has been successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the message {0}?",
    "New item": "New message",
    "New item fail": "Error sending the message.",
    "New item success": "Message has been sent successfully.",
    "Send text": "Ctrl + Enter to send"
  },
  "No": "No",
  "Not applicable": "N/a.",
  "Personal_data_form": {
    "Answer": "I consent to the processing of personal data.",
    "Answer_false": "I do not consent to the processing of personal data.",
    "Answer_representative": "I consent to the processing of personal data.",
    "Answer_true": "I consent to the processing of personal data.",
    "Attachment": "Attachment",
    "Cancelled": "Expire",
    "Client": "Client",
    "Consent message": "In Europe, privacy laws apply to the processing of important data. We call this data \"personal data\", it concerns data that can be traced back to an individual. Healthcare institutions process and use a lot of personal data of their residents and participants, for example, we keep residents' health cards and we make detailed plans that contain a lot of personal data of participants. Think of social security numbers, dates of birth and medical information.\n\nIt goes without saying that it is important that we handle your data with care, one of the requirements is that we can demonstrate that we have your permission to process data from you or your relative. It must also be easy for you to withdraw that consent.\n\nYou can give us permission to process your data by signing the statement below, in the same way you can withdraw your original consent if, for example, you or your relative no longer receive care from us.\n\nYou have the right to request that we delete your data, and we will do so without delay upon your request. We will also pass on your request to other organisations that have received or use data from us.\n\nWe are also legally obliged to appoint a data protection officer, a so-called DPO. For Nocht en Wille Zorg, we have appointed a DPO and reported this to the Dutch Data Protection Authority.\n\nI, legal representative of {client}, hereby grant permission to Nocht en Wille Zorg BV and its affiliated companies to process all (personal) data that is necessary for the provision of good and responsible care.",
    "Delete": "delete",
    "Delete item": "Delete data processing consent form",
    "Delete item fail": "Error deleting the data processing consent form.",
    "Delete item success": "Data processing consent form successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the data processing consent form?",
    "Deleted": "Deleted",
    "Document is cancelled": "The document has expired.",
    "Document is expired": "Please note: the validity of the document has expired!",
    "Document is final": "The document has been finalized and can no longer be changed.",
    "Documents awaits signing by representative": "The document is pending signature of the representative and can no longer be changed.",
    "Documents awaits signing by supplier": "The document is pending signature by Nocht and Wille and can no longer be changed.",
    "Edit item": "Edit data processing consent form",
    "Edit item fail": "Error changing the data processing consent form. The data processing consent form has not been changed.",
    "Edit item success": "Data processing consent form successfully modified.",
    "Editable_by": "Editable by",
    "Employee_signature": "Employee signature",
    "Employee_signature_date": "Employee signature date",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REPRESENTATIVE_SIGN_CONSENT": "You must give your consent before you can sign the document."
    },
    "Form client birthdate": "Date of birth",
    "Form client name": "Consent form from",
    "Form_valid_until": "Valid Until",
    "New item": "Data processing consent form",
    "New item fail": "Error adding the data processing consent form.",
    "New item success": "Data processing consent form successfully added.",
    "Only editable by representative": "The document can currently only be changed by representatives.",
    "Only editable by supplier": "The document can currently only be changed by Nocht and Wille.",
    "Personal Data Protocol List": "Data processing consent",
    "Replaced_by": "Replaced by",
    "Representative_signature": "Representative signature",
    "Representative_signature_date": "Representative signature date",
    "Sign_consent": "Document consent",
    "Sign_consent_text": "I confirm that I have read this document and agree with its contents as described.",
    "Signed_by_employee": "Sign on behalf of Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Signing on behalf of client",
    "Start signing form message": "Choose the name of the representative and employee who will sign the document.\n\nThe representative will receive an email with a signing request, after signing by the agent, the employee will receive a signing request.",
    "Start signing item": "Making it final",
    "User": "User"
  },
  "Photo_film_form": {
    "Access_how": "How can we use the photos and videos?",
    "Access_how_representative": "How can we use the photos and videos?",
    "Answer": "Permission:",
    "Answer_false": "No, Nocht en Wille Zorg is not allowed to take photos and videos of my relative.",
    "Answer_representative": "Consent (representative)",
    "Answer_true": "Yes, Nocht en Wille Zorg is allowed to take photos and videos of my relative.",
    "Consent explanation": "At our locations, during activities or on other occasions, we sometimes want to take photos and/or videos of residents and participants. Sometimes we do this to analyze the images so that we can improve the care provided, sometimes we do it to capture beautiful moments that we experience together.",
    "Consent message": "The undersigned hereby declares that she has been informed about the privacy policy within Nocht en Wille Zorg through the privacy and personal data folder.",
    "Delete item": "Delete permission form for the use of photo and film material",
    "Delete item fail": "Error deleting the consent form.",
    "Delete item success": "Consent form successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the consent form for the use of photo and film material?",
    "Document is cancelled": "The document has expired.",
    "Document is expired": "Please note: the validity of the document has expired!",
    "Document is final": "The document has been finalized and can no longer be changed.",
    "Documents awaits signing by representative": "The document is pending signature of the representative and can no longer be changed.",
    "Documents awaits signing by supplier": "The document is pending signature by Nocht and Wille and can no longer be changed.",
    "Edit item": "Edit consent form",
    "Edit item fail": "Error changing the consent form. Consent form not changed.",
    "Edit item success": "Edited consent form.",
    "Editable_by": "Editable by",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REPRESENTATIVE_SIGN_CONSENT": "You must give your consent before you can sign the document."
    },
    "Form client birthdate": "Date of Birth",
    "Form client name": "Consent form from",
    "New item": "Permission form for the use of photo and film material",
    "New item fail": "Error adding the consent form for the use of photo and film material.",
    "New item success": "Permission form for the use of photo and film material successfully created.",
    "Only editable by representative": "The document can currently only be changed by representatives.",
    "Only editable by supplier": "The document can currently only be changed by Nocht and Wille.",
    "Photo Film Protocol List": "Permission form for the use of photo and film material",
    "Sign_consent": "Document consent",
    "Sign_consent_text": "I confirm that I have read this document and agree with its contents as described.",
    "Signed_by_employee": "Sign on behalf of Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Signing on behalf of client"
  },
  "Protocols_and_forms": {
    "Created": "Created",
    "Editable_by": "Editable by",
    "EditableByOptions": {
      "Representative": "Representative",
      "Supplier": "Nocht en Wille"
    },
    "FormTypes": {
      "Bathing_swimming_form": "Bathing and swimming appointments",
      "Camera_surveillance_form": "Camera and audio surveillance permission form",
      "Epilepsy_protocol": "Epilepsy",
      "File_insight_form": "Permission to inspect the support plan",
      "Gp_execution_request_form": "Implementation request GP",
      "Personal_data_form": "Data processing consent form",
      "Photo_film_form": "Permission to use photo and film material",
      "Reanimation_form": "Agreements on medical treatment"
    },
    "ShowArchived": "Show archived items",
    "Status": "Status",
    "StatusOptions": {
      "CANCELLED": "Cancelled",
      "CONCEPT": "Concept",
      "EXPIRED": "Expired",
      "FINAL": "Definitive",
      "SIGN_EMPLOYEE": "Drawing (employee)",
      "SIGN_REPRESENTATIVE": "Signing (representative)",
      "SUPERSEDED": "Replace"
    },
    "Type": "Type",
    "User": "Employee",
    "Valid until": "Valid until"
  },
  "Quality_manual": {
    "Delete": "remove",
    "Delete document item": "Delete File",
    "Delete document item fail": "Error deleting file.",
    "Delete document item success": "File deleted successfully.",
    "Delete document item text": "Are you sure you want to {1} the file {0}?",
    "Delete folder item": "Delete folder",
    "Delete folder item fail": "The folder could not be deleted. ",
    "Delete folder item success": "Folder deleted successfully.",
    "Delete folder item text": "{2}Are you sure you want to {1} the folder {0}?",
    "Deletion of data recursive": "All underlying folders and files will also be deleted!",
    "Description": "Description",
    "Edit document item": "Edit file",
    "Edit document item fail": "Error editing file.",
    "Edit document item success": "File successfully modified.",
    "Edit folder item": "Edit folder",
    "Edit folder item fail": "The folder could not be changed. ",
    "Edit folder item success": "Folder successfully modified.",
    "Error loading data": "The quality manual could not be loaded.",
    "File": "File",
    "Name": "Name",
    "New document item": "Add new file",
    "New document item fail": "Error adding the file.",
    "New document item success": "New file added successfully.",
    "New folder item": "New Folder",
    "New folder item fail": "Error adding the folder.",
    "New folder item success": "New folder created successfully.",
    "Nothing to show": "No results found.",
    "Original_filename": "Original file name",
    "Parent folder": "Parent folder",
    "Preview file item": "Preview",
    "Show list view": "List view",
    "Show tree view": "Tree view"
  },
  "Reanimation_form": {
    "Action": "Action",
    "Client information": "Client information",
    "Consent message": "By signing this statement, I hereby indicate my wishes regarding various (medical) situations that may occur with the person I legally represent",
    "Delete": "remove",
    "Delete item": "Remove agreements about medical treatment",
    "Delete item fail": "Error in removing the agreements on medical treatment.",
    "Delete item success": "Agreements on medical treatment successfully removed.",
    "Delete item text": "Are you sure you want to {1} the agreements on medical treatment?",
    "Do or do not": "Do's and don'ts",
    "Do/not": "Yes/No",
    "Document is cancelled": "The document has expired.",
    "Document is expired": "Please note: the validity of the document has expired!",
    "Document is final": "The document has been finalized and can no longer be changed.",
    "Documents awaits signing by representative": "The document is pending signature of the representative and can no longer be changed.",
    "Documents awaits signing by supplier": "The document is pending signature by Nocht and Wille and can no longer be changed.",
    "Edit item": "Agreements on medical treatment edit",
    "Edit item fail": "Error in editing the agreements on medical treatment. The agreements on medical treatment have not changed.",
    "Edit item success": "Agreements on medical treatment successfully changed.",
    "Editable_by": "Editable by",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REPRESENTATIVE_SIGN_CONSENT": "You must give your consent before you can sign the document."
    },
    "Explanation": "In the context of the Medical Treatment Agreement Act (WGBO), prior to completing this form, consultation must take place between the treated doctor and the client/legal representative.",
    "Form client address": "Address",
    "Form client birthdate": "Date of birth",
    "Form client BSN": "BSN",
    "Form client name": "Name",
    "Motivation": "Personal image and motivation",
    "Motivation_representative": "Remarks representative(s)",
    "New item": "Agreements on medical treatment",
    "New item fail": "Error in adding the agreements on medical treatment.",
    "New item success": "Agreements on medical treatment successfully created.",
    "Only editable by representative": "The document can currently only be changed by representatives.",
    "Only editable by supplier": "The document can currently only be changed by Nocht and Wille.",
    "Perform_hospitalisation": "Hospitalization",
    "Perform_hospitalisation_representative": "Hospitalization",
    "Perform_intensive_care": "ICU admission",
    "Perform_intensive_care_representative": "ICU admission",
    "Perform_reanimation": "Resuscitation",
    "Perform_reanimation_representative": "Resuscitation",
    "Perform_respiration": "Rescue breath",
    "Perform_respiration_representative": "Rescue breath",
    "Representatives notes": "Remarks representative(s)",
    "Sign_consent": "Document consent",
    "Sign_consent_text": "I confirm that I have read this document and agree with its contents as described.",
    "Signed_by_employee": "Sign on behalf of Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Signing on behalf of client"
  },
  "Report": {
    "Add new report": "Create new @:{report}report | Create new @:{report}",
    "Added by": "Added By",
    "Aggression_nature": "Nature of aggression",
    "Aggression_to": "Aggression towards",
    "Agressie": "Aggression",
    "Aid objects": "Aid objects",
    "Amount": "Quantity",
    "Attachment": "Attachment",
    "Attachment_signoff": "Sign-off list",
    "Audio_recording": "Audio recording",
    "Behavior": "Behavior",
    "Behaviour": "Behavior",
    "Bread_amount": "Number of sandwiches",
    "Cause": "Cause",
    "Client": "Customer",
    "Client name": "Client name",
    "Consistency": "Type",
    "Created": "Added on",
    "Date": "Date",
    "Day": "Daily reports",
    "Delete item text": "Are you sure you want to {1} the {0} ?",
    "Deleted": "Deleted",
    "Duration": "Duration in minutes",
    "Edit item": "Edit report",
    "Editable_by": "Editable by",
    "Epilepsie": "Epilepsy",
    "Epilepsy": "Epilepsy",
    "Epilepsy_notes": "Epilepsy report",
    "Errors": {
      "Max_digits": "Make sure there are no more than 3 digits in total"
    },
    "Excrement": "Excrement",
    "Falling": "Falling",
    "Files": "Files",
    "Finalized": "Finalized",
    "Fobo": "FOBO",
    "Fobo report": "FOBO-",
    "Food": "What was eaten?",
    "Food report": "Food",
    "Food_full": "What was eaten?",
    "Had_clothing": "Dressed",
    "Involved": "Involved",
    "Location": "Location",
    "Medical file": "Medical file",
    "Medicatie": "Medication",
    "Medication": "Medications/fluid name",
    "Medicine": "Emergency medication used",
    "Message": "Message",
    "Name": "Name",
    "Nature_of_incident": "Nature of incident",
    "New item": "New report",
    "No access to audio": "No access to audio recording",
    "No access to attachment": "No access to attachment",
    "Notes": "Details",
    "Number_of_drinks": "Number of cups to drink",
    "Ongewenst_gedrag": "Undesirable behaviour",
    "Other": "Other",
    "Overige": "Other",
    "Priority": "High priority",
    "Protocols and forms": "Protocols and consent forms",
    "Quoted_message": "Message",
    "Read less": "Read less...",
    "Read more": "Read more...",
    "Recommendation": "Advice on long-term measures",
    "Remediation": "Immediate action or measure taken",
    "Shift": "Shift",
    "Support plans": "Support plans",
    "Tabs": {
      "General": "General"
    },
    "Temperature": "Temperature",
    "Thermometer_measurement": "Thermometer measurement",
    "Thermometer_type": "Type of thermometer",
    "Time": "Time",
    "Undesired_behaviour": "Undesirable behaviour",
    "Vallen": "Fallen",
    "Verslikking": "Choking",
    "Walk_away": "Ran away",
    "Weglopen": "Abscond",
    "Weight": "Weight",
    "Weight report": "Weight report",
    "Wet zorg en dwang": "WZD Registrations",
    "When": "When",
    "Where": "Scene of the event"
  },
  "Role": {
    "Assign": "Assign",
    "Assign client roles": "Assign client user roles",
    "Assign representative roles": "Assign representative roles",
    "Assign roles": "Assign roles",
    "Assign user roles": "Assign employee roles",
    "Clients": "Clients",
    "Delete item": "Delete role",
    "Delete item fail": "Error deleting the role.",
    "Delete item success": "Roll successfully deleted.",
    "Delete item text": "Are you sure you want to {1}the role {0} ?",
    "Description": "Description",
    "Edit item": "Edit role",
    "Edit item fail": "Error changing the role.",
    "Edit item success": "Role successfully changed.",
    "Error loading data": "The list of roles could not be loaded.",
    "Friendly_name": "Friendly name",
    "Import roles": "Import roles",
    "Import roles warning": "{note}: Import updates the role and permission matrix from an Excel file. Always start from a recent export and review the changes carefully before importing.",
    "Locations": "Locations",
    "Name": "Name",
    "New item": "New role",
    "New item fail": "Error creating the roll.",
    "New item success": "Role successfully added.",
    "None assigned": "None assigned",
    "ObjectName": "Role",
    "Permissions": "Permissions",
    "Representative": "Representative",
    "Revert": "Revert step",
    "Roles": "Roles",
    "Services": {
      "Aid object": "Aid object",
      "Bathing swimming form": "Bathing swimming form",
      "Behaviour goal": "Behaviour goal",
      "Behaviour goal message": "Behaviour goal message",
      "Camera surveillance form": "Camera surveillance form",
      "Client": "Client",
      "Client care": "Client care",
      "Client file": "Client file",
      "Client goal": "Client goal",
      "Contact": "Contact",
      "Day report": "Day report",
      "Day report message": "Day report message",
      "Epilepsy protocol": "Epilepsy protocol",
      "Epilepsy report": "Epilepsy report",
      "Excrement report": "Excrement report",
      "File insight form": "File insight form",
      "File tree": "File tree",
      "File tree category": "File tree category",
      "File tree document": "File tree document",
      "Fobo report": "Fobo report",
      "Food report": "Food report",
      "General practitioner": "General practitioner",
      "Goal report": "Goal report",
      "Gp execution request form": "Gp execution request form",
      "Location": "Location",
      "Location appointment": "Location appointment",
      "Location flush report": "Location flush report",
      "Location flush report item": "Location flush report item",
      "Location memo": "Location memo",
      "Location presence": "Location presence",
      "Location tap point": "Location tap point",
      "Location task category": "Location task category",
      "Location task item": "Location task item",
      "Location task template": "Location task template",
      "Location temperature report": "Location temperature report",
      "Location temperature report item": "Location temperature report item",
      "Location user role": "Location user role",
      "Location workorder": "Location workorder",
      "Medical file": "Medical file",
      "Medical file involved": "Medical file involved",
      "Medical report": "Medical report",
      "Message board": "Message board",
      "Message board message": "Message board message",
      "Personal data form": "Personal data form",
      "Photo film form": "Photo film form",
      "Quality manual category": "Quality manual category",
      "Quality manual document": "Quality manual document",
      "Reanimation form": "Reanimation form",
      "Role": "Role",
      "Roles": "Roles",
      "Support plan": "Support plan",
      "Temperature report": "Temperature report",
      "User": "User",
      "User logon device": "User logon device",
      "User role": "User role",
      "Weight report": "Weight report",
      "Wzd registration": "Wzd registration"
    },
    "Stepper": {
      "Steps": {
        "Select client and roles": "Roles per client",
        "Select client and roles description": "Review all assigned roles per level before saving the configuration.",
        "Select client and roles title": "Which roles do you want to assign to this {userType} per client?",
        "Select location and roles": "Roles per location",
        "Select location and roles description": "Assign specific roles that apply only within the selected locations.",
        "Select location and roles title": "Which roles do you want to assign to this {userType} per location?",
        "Select user": "Select user",
        "Select user description": "Select the {userType} for whom you want to configure permissions.",
        "Select user roles": "General roles",
        "Select user roles description": "These roles apply regardless of location or client.",
        "Select user roles title": "Which general roles do you want to assign to this {userType}?",
        "Select user title": "Which {userType} do you want to assign roles to?",
        "Summary": "Summary",
        "Summary description": "Review all assigned roles per level before saving the configuration.",
        "Summary title": "Summary of role assignments"
      }
    },
    "Type": "Type",
    "User": "Employee",
    "User roles": "Employee roles"
  },
  "Save": "Save",
  "Save and add another": "Save and add new",
  "Save and close": "Save & close",
  "Save and stay": "Save & stay",
  "Save and sync": "Save & Sync",
  "Save, sync and close": "Save, sync, and close",
  "Services": {
    "Aid object": "Aid object",
    "Bathing swimming form": "Bathing swimming form",
    "Behaviour goal": "Behaviour goal",
    "Behaviour goal message": "Behaviour goal message",
    "Camera surveillance form": "Camera surveillance form",
    "Client": "Client",
    "Client care": "Client care",
    "Client file": "Client file",
    "Client goal": "Client goal",
    "Contact": "Contact",
    "Day report": "Day report",
    "Day report message": "Day report message",
    "Epilepsy protocol": "Epilepsy protocol",
    "Epilepsy report": "Epilepsy report",
    "Excrement report": "Excrement report",
    "File insight form": "File insight form",
    "File tree": "File tree",
    "File tree category": "File tree category",
    "File tree document": "File tree document",
    "Fobo report": "Fobo report",
    "Food report": "Food report",
    "General practitioner": "General practitioner",
    "Goal report": "Goal report",
    "Gp execution request form": "Gp execution request form",
    "Location": "Location",
    "Location appointment": "Location appointment",
    "Location flush report": "Location flush report",
    "Location flush report item": "Location flush report item",
    "Location memo": "Location memo",
    "Location presence": "Location presence",
    "Location tap point": "Location tap point",
    "Location task category": "Location task category",
    "Location task item": "Location task item",
    "Location task template": "Location task template",
    "Location temperature report": "Location temperature report",
    "Location temperature report item": "Location temperature report item",
    "Location user role": "Location user role",
    "Location workorder": "Location workorder",
    "Medical file": "Medical file",
    "Medical file involved": "Medical file involved",
    "Medical report": "Medical report",
    "Message board": "Message board",
    "Message board message": "Message board message",
    "Personal data form": "Personal data form",
    "Photo film form": "Photo film form",
    "Quality manual category": "Quality manual category",
    "Quality manual document": "Quality manual document",
    "Reanimation form": "Reanimation form",
    "Role": "Role",
    "Support plan": "Support plan",
    "Temperature report": "Temperature report",
    "User": "User",
    "User logon device": "User logon device",
    "User role": "User role",
    "Weight report": "Weight report",
    "Wzd registration": "Wzd registration"
  },
  "Support_plan": {
    "Agreements": "Appointments",
    "Attachment": "Attachment",
    "Attention_points": "It is necessary to pay attention to:",
    "Attention_points_representative": "It is necessary to pay attention to (representative):",
    "Autosave is disabled": "Autosave is disabled.",
    "Autosave is enabled": "Auto save is enabled.",
    "Cancelled": "Expire",
    "Care needs of the participant": "Care request of the participant",
    "Client": "Customer",
    "Client_aid": "How do we help the participant achieve these overarching goals?",
    "Client_aid_representative": "How do we help the participant achieve these overarching goals (representative)?",
    "Client_future": "What does the future of the participant look like?",
    "Client_future_representative": "What does the future of the participant look like? (representative)",
    "Client_goals": "What overarching goals does the participant want to achieve?",
    "Client_goals_representative": "What overarching goals does the participant want to achieve (representative)?",
    "Client_treatment": "What is the participant's care needs?",
    "Client_treatment_representative": "What is the care question of the participant (representative)?",
    "Communication and interaction": "What does the interaction and communication with the participant look like?",
    "Contact_decisions": "Decisions that should only be made after consultation with parents/representatives:",
    "Contact_decisions_representative": "Decisions that should only be made after consultation with parents/representatives (representative):",
    "Contact_situations": "In which situations should Nocht en Wille contact parents/representatives directly?",
    "Contact_situations_representative": "In which situations should Nocht en Wille contact parents/representatives (representative) directly?",
    "Created": "Created at",
    "Delete": "Remove",
    "Delete item": "Remove support plan",
    "Delete item fail": "Error deleting support plan.",
    "Delete item success": "Support plan successfully removed.",
    "Delete item text": "Are you sure you want to {1}the support plan?",
    "Deleted": "Filed",
    "Disable autosave": "Disable",
    "Document is cancelled": "The document has expired.",
    "Document is expired": "Please note: the validity of the document has expired!",
    "Document is final": "The document has been finalized and can no longer be changed.",
    "Documents awaits signing by representative": "The document is pending signature of the representative and can no longer be changed.",
    "Documents awaits signing by supplier": "The document is pending signature by Nocht and Wille and can no longer be changed.",
    "Edit item": "Edit support plan",
    "Edit item fail": "Error editing the support plan. The support plan has not changed.",
    "Edit item success": "Support plan successfully created.",
    "Editable_by": "Editable by",
    "EditableByOptions": {
      "Representative": "Representative",
      "Supplier": "Nocht en Wille"
    },
    "Employee_signature": "Employee signature",
    "Employee_signature_date": "Employee signature date",
    "Enable autosave": "Enable",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REPRESENTATIVE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REVERT_NOT_AVAILABLE": "The support plan cannot be reset to the concept phase."
    },
    "General_report": "General report. How did the past year go? (briefly)",
    "General_report_representative": "General report. How did the past year go (briefly, representative)?",
    "Goal_1": "Goal 1",
    "Goal_1_representative": "Aim 1 (Representative)",
    "Goal_2": "Goal 2",
    "Goal_2_representative": "Goal 2 (Representative)",
    "Limitations": "What (mitigating) measures are being taken to prevent these risks?",
    "Limitations_representative": "What (mitigating) measures are being taken to prevent these risks? (representative)",
    "Medical history": "Medication/Medical history",
    "Medication": "Medication",
    "Medication_history": "Medical History",
    "Medication_history_representative": "Medical history (representative)",
    "Medication_representative": "Medication (representative)",
    "Meeting_summary": "Short summary OP discussion",
    "Meeting_summary_representative": "Summary OP Discussion (Representative)",
    "Modified": "Edited on",
    "Name": "Name",
    "New item": "New support plan",
    "New item fail": "Error adding the support plan.",
    "New item success": "Support plan successfully created.",
    "Not_met_support": "Support questions that Nocht en Wille cannot meet:",
    "Not_met_support_representative": "Support questions that Nocht en Wille cannot meet (representative):",
    "Only editable by representative": "The document can currently only be changed by representatives.",
    "Only editable by supplier": "The document can currently only be changed by Nocht and Wille.",
    "Plan_valid_until": "Valid Until",
    "Replaced_by": "Replaced by",
    "Report": "Report",
    "Representative_signature": "Representative signature",
    "Representative_signature_date": "Representative signature date",
    "Risks and limitations": "Risks and limitations",
    "Risks_others": "Risks to others",
    "Risks_others_representative": "Risks to others (representative)",
    "Risks_self": "Risks to themselves",
    "Risks_self_representative": "Risks to oneself (representative)",
    "Role_guardians": "What is the role of parents/informal caregivers with regard to care and support and with regard to the realization of the set goals?",
    "Role_guardians_representative": "What is the role of parents/informal caregivers with regard to the care and support and with regard to the realization of the set goals (representative)?",
    "Role_partners": "Who are the collaborating partners with regard to care and support? What is their role with regard to the provision of care and the goals set?",
    "Role_partners_representative": "Who are the collaborating partners with regard to care and support? What is their role with regard to the provision of care and the set goals (representative)?",
    "ShowArchived": "Show archived items",
    "Sign_consent": "Document consent",
    "Sign_consent_text": "I confirm that I have read this document and agree with its contents as described.",
    "Signed": "Signed on",
    "Signed_by_employee": "Sign on behalf of Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Signing on behalf of client",
    "since": "since",
    "Status": "Status",
    "StatusOptions": {
      "CANCELLED": "Canceled",
      "CONCEPT": "Concept",
      "EXPIRED": "Expired",
      "FINAL": "Final",
      "SIGN_EMPLOYEE": "Signing (employee)",
      "SIGN_REPRESENTATIVE": "Signing (representative)",
      "SUPERSEDED": "Superseded"
    },
    "Supportplan of": "Support plan of",
    "Transport": "Transport",
    "Transport_representative": "Transport (representative)",
    "Transportation": "Transport",
    "Treatment_activities": "Activities",
    "Treatment_activities_representative": "Activities (representative)",
    "Treatment_communication": "Communication",
    "Treatment_communication_representative": "Communication (representative)",
    "Treatment_drink": "Drink",
    "Treatment_drink_representative": "Drink (representative)",
    "Treatment_food": "Eat",
    "Treatment_food_representative": "Food (representative)",
    "Treatment_grooming": "Care",
    "Treatment_grooming_representative": "Care (representative)",
    "Treatment_movement": "Exercise and the outdoors",
    "Treatment_movement_representative": "Exercise and outdoor air (representative)",
    "Treatment_sexuality": "Sexuality",
    "Treatment_sexuality_representative": "Sexuality (representative)",
    "Treatment_sleep": "Sleep",
    "Treatment_sleep_representative": "Sleeping (representative)",
    "Treatment_transfer": "Transfer",
    "Treatment_transfer_representative": "Transfer (representative)",
    "Treatment_water": "Bathing, showering and swimming",
    "Treatment_water_representative": "Bathing, showering and swimming (representative)",
    "Valid until": "Valid Until",
    "Who_is_client": "Who is the participant",
    "Who_is_client_representative": "Who is the participant (representative)"
  },
  "Temperature": {
    "Added by": "Added By",
    "Cause": "Cause",
    "Client": "Client",
    "Client name": "Client name",
    "Created": "Created at",
    "Date": "Date",
    "Delete item": "Delete Report",
    "Delete item fail": "Error deleting the report.",
    "Delete item success": "Report successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the {0}?",
    "Edit item": "Temperature report",
    "Edit item fail": "Error changing the temperature report. Temperature report not changed.",
    "Edit item success": "Temperature report successfully modified.",
    "Editable_by": "Editable by",
    "Name": "Name",
    "New item": "New report",
    "New item fail": "Error creating the new temperature report.",
    "New item success": "Temperature report added successfully.",
    "ObjectName": "Temperature report | Temperature reports",
    "Temperature": "Temperature",
    "Thermometer_measurement": "Thermometer measurement",
    "Thermometer_type": "Type of thermometer",
    "Time": "Time"
  },
  "User": {
    "After Authenticator QR scan": "After scanning the QR code, click {0}.",
    "After install authenticator next": "After installing the Authenticator app on your device, click {0}.",
    "After setup authenticator account next": "When you're ready to continue, click {0}.",
    "Already has account": "Already have an account? To log in, go to the",
    "Already logged in": "Another user is logged in. Log out first, then try again",
    "Assigned roles": "Assigned roles",
    "Authenticator allow notifications": "When prompted, allow notifications.",
    "Authenticator select other account": "Then add an account. When using the Microsoft Authenticator app, make sure you select \"Other account\".",
    "Back to login": "Back to login",
    "Back to password reset request": "Request a new password",
    "Cannot scan QR code?": "QR code isn't working?",
    "Capslock enabled": "Caps Lock is enabled.",
    "Change email item fail": "Changing the email address was not successful. Please check the marked field and try again.",
    "Change photo": "Change photo",
    "Change view": "Change view",
    "Confirm identity fail": "Error confirming user.",
    "Confirm identity success": "User has been successfully confirmed.",
    "Current email": "Current email address",
    "Delete": "Remove",
    "Delete item": "Delete user",
    "Delete item fail": "Error deleting user.",
    "Delete item success": "User successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the account for {0}?",
    "Delete user": "Delete user",
    "Delete user fail": "The user could not be deleted.",
    "Delete user success": "User successfully deleted.",
    "Delete user text": "Are you sure you want to {1}the account for {0}?",
    "Dialog confirm resend invite": {
      "Message": "Are you sure you want to send the invite?",
      "Title": "Send invite"
    },
    "Dialog confirm reset password": {
      "Message": "Are you sure you want to reset the password for user {user}?",
      "Title": "Reset password"
    },
    "Download Authenticator app": "Download Authenticator app",
    "Download authenticator first": "Download the app first",
    "Edit item": "Edit User",
    "Edit item email fail": "Error requesting the email address change. The email details have not changed.",
    "Edit item fail": "Error editing the user. The user hasn't changed.",
    "Edit item profile": "Edit Profile",
    "Edit item success": "User successfully modified.",
    "Edit user": "Change User",
    "Edit user email fail": "Error requesting the change of email address. Email address has not changed.",
    "Edit user fail": "Error when changing the user. User has not changed.",
    "Edit user success": "User successfully modified.",
    "Email": "E-mail address",
    "Email change": "To make it @.lower:User. Email definitely, there is a message to the new @.lower:User. Sent an email with instructions.",
    "Email change success": "The @.lower:User.Email is confirmed. You can now login with your new @.lower:User.Email to login.",
    "Email check": "Check the e-mail address.",
    "Email edit": "Click on the pen icon to change the password.",
    "Email edit message": "You can change the email address below. {0}{1}{2}{3} It is mandatory to confirm the new email address. Follow the instructions in the email sent to the new email address.",
    "Email in use": "The email address you entered is already in use.",
    "Email invalid": "E-mail address is not valid.",
    "Email mandatory": "Email address is required.",
    "Error loading data": "The list of users could not be loaded due to an error.",
    "Errors": {
      "Biometrics blocked error": "Touch ID/Face ID verification failed too often and is blocked. Try again later.",
      "Biometrics error": "You are logged out Touch ID/Face ID verification failed.",
      "Profile error": "You have not (yet) been assigned a valid ECD profile, please contact the administrator.",
      "Timeout error": "You are logged out due to inactivity.",
      "TOTP_TOKEN_INVALID": "MFA token is invalid."
    },
    "First name mandatory": "First name is required.",
    "First_name": "First Name",
    "FirstName": "First Name",
    "FirstName mandatory": "First name is required.",
    "Forgot": "Forgot password",
    "Full name": "Full name",
    "Install authenticator on phone": "Install the {0} app or the {1} app on your phone.",
    "Is_attendant": "Is an attendant",
    "Is_living_location_caretaker": "Is concierge",
    "Is_location_coordinator": "Is location coordinator",
    "Is_management": "Is management",
    "Is_mentor": "Is a mentor",
    "Is_personal_attendant": "Is a personal supervisor",
    "Is_superuser": "Is superuser?",
    "Is_technical_services": "Is technical maintenance",
    "Is_trustee": "Is a curator",
    "IsSSO": "Via SSO?",
    "Keep me logged in": "Keep me logged in",
    "Last name mandatory": "Last name is required.",
    "Last_name": "Surname",
    "LastName": "Surname",
    "LastName mandatory": "Last name is required.",
    "Locale": "Language",
    "LocaleOptions": {
      "En-US": "@:Languages. English",
      "Nl-NL": "@:Languages. English"
    },
    "Locations": "Locations",
    "Login": "Employee login",
    "Login failed": "The username/password combination is incorrect.",
    "Login header": "Log in",
    "Login help": "Need help logging in?",
    "Login success": "You have successfully logged in.",
    "Login user": "Login",
    "Lost MFA code?": "Lost your code?",
    "Manually add code": "Manually add the following code into the Authenticator app.",
    "Mark self": "You",
    "MFA enter code": "Enter the code that is displayed in the Authenticator app.",
    "MFA lost code": "Please send an email to {0} requesting the removal of your security settings. For your safety, we will need to verify your identity to complete this process. To ensure the process goes smoothly, we request that you send the email preferably from the same email address and include your customer number.",
    "MFA lost code after setup": "If you lose the code, please send an email to {0} requesting the removal of your security settings. For your safety, we will need to verify your identity to complete this process. To ensure the process goes smoothly, we request that you send the email preferably from the same email address and include your customer number.",
    "Mfa reset item fail": "MFA reset failed.",
    "Mfa reset item success": "MFA reset successfully.",
    "MFA setup completed": "Completed!",
    "MFA setup completed text": "You have successfully setup your security info. Choose {0} to continue signing in.",
    "MFA Status": "MFA Status",
    "MFA verify failed": "The provided code is invalid.",
    "Name": "Name",
    "New item": "New User",
    "New item fail": "Error adding the user.",
    "New item success": "User successfully created.",
    "New representative": "Add representative",
    "New representative item": "New representative",
    "New user": "Add user",
    "New user fail": "Error creating the user.",
    "New user success": "User created successfully.",
    "Password": "Password",
    "Password change": "Change Password",
    "Password change message": "To change the password, you need to enter your old password and the new password twice.",
    "Password change set": "Enter your desired password and confirm it.",
    "Password checks": {
      "At least n Characters": "Password is at least {n} characters long",
      "Contains numbers": "Contains at least one digit",
      "Contains special char": "Contains at least one special character",
      "Contains uppercase": "Contains at least one uppercase letter",
      "Digits": "The password must contain at least 1 digit",
      "Lowercase": "The string should have a minimum of 1 lowercase letter",
      "Min": "The password must be at least {n} characters long",
      "Not_same": "New passwords are not the same",
      "Passwords different then old password": "Password is not the same as the current password",
      "Passwords equal": "Both passwords are the same",
      "Same_old": "The new password is the same as the old password",
      "Symbols": "The password must contain at least 1 symbol",
      "Uppercase": "The password must contain at least 1 uppercase letter"
    },
    "Password confirm": "Repeat password",
    "Password current": "Current Password",
    "Password fail": "Check the password",
    "Password mandatory": "Password is required.",
    "Password new": "New Password",
    "Password reset": "Reset Password",
    "Password reset fail": "Password reset could not be performed.",
    "Password reset new text": "Please enter the new password below.",
    "Password reset request success": "A password reset email has been sent to {email}.",
    "Password reset success": "The password has been successfully updated.",
    "Password reset text": "Enter the user's email address, whose password needs to be reset.",
    "Password reset token invalid": "The link is invalid or has expired.",
    "Photo": "Photo",
    "Profile photo": "Profile picture",
    "Refresh list": "Refresh list of users",
    "RegionalSetting": "Regional breakdown",
    "RegionalSettingOptions": {
      "En-US": "@:Languages. English",
      "Nl-NL": "@:Languages. English"
    },
    "Request forgot": "Request a new password",
    "Resend invite": "Send invite",
    "Resend invite item success": "Invite successfully sent.",
    "ResendInvite item": "Invite",
    "Reset mfa": "Restore",
    "Reset password": "Reset password",
    "Reset password item fail": "Failed to reset password.",
    "Reset password item success": "Password successfully reset.",
    "ResetMFA": "Restore MFA",
    "ResetMFA item fail": "Error restoring MFA for user}.",
    "ResetMFA item success": "MFA reset successfully for user.",
    "ResetMFA item text": "Are you sure you want to {1} MFA for {0}?",
    "Role": "Role",
    "Roles": {
      "ADMINISTRATOR": "Administrator",
      "ATTENDANT": "Attendant",
      "EMPLOYEE": "Employee",
      "LOCATION_COORDINATOR": "Location Coordinator",
      "MANAGEMENT": "Management",
      "PERSONAL_ATTENDANT": "Personal supervisor",
      "REPRESENTATIVE": "Representative",
      "TECHNICAL_SERVICES": "Technical service"
    },
    "Roles mandatory": "At least 1 role must be assigned",
    "Scan QR code": "Scan the QR code",
    "Send_invite": "Send invitation",
    "Set password": "Set Password",
    "Setup authenticator account": "Setup authenticator account",
    "Setup your authenticator account": "Setup your account",
    "SSO Microsoft": "Login via {0} Microsoft",
    "Tabs": {
      "General": "General",
      "Roles": "Role assignments"
    },
    "Trust MFA device": "Trust this device for 14 days",
    "Trust MFA device info": "By default, your account stays logged in automatically for one day. If you choose to trust this device, your account will stay logged in for 30 days. When you manually log out, verification will always be required again.",
    "Upload ID": "Upload ID",
    "Upload insurance": "Upload insurance",
    "Use Authenticator app to scan QR code": "Use the Authenticator app to scan the QR code. This will connect the Authenticator app with your account.",
    "Verify": "Verify",
    "Verify code": "Verify the code",
    "Verify MFA": "Verify code",
    "Verify MFA text": "Please confirm your login by entering the code displayed in your Authenticator app on your device.",
    "Verify token invalid": "The link is invalid or has expired."
  },
  "User_role": {
    "Delete item": "Delete role assignment",
    "Delete item fail": "Error deleting the role assignment.",
    "Delete item success": "Role assignment successfully removed.",
    "Delete item text": "Are you sure you want to {1}the role assignment?",
    "Edit item": "Edit role assignment",
    "Edit item fail": "Error changing the role assignment.",
    "Edit item success": "Role assignment successfully changed.",
    "Error loading data": "The list of role assignments could not be loaded.",
    "New item": "New role assignment",
    "New item fail": "Error creating the role assignment.",
    "New item success": "Role assignment successfully added.",
    "Role": "Role",
    "User": "Employee"
  },
  "Vecozo_toegewezen_zorg_zwaarte_pakket": {
    "ShowSuperseded": "Superseded assignments"
  },
  "Vecozo_message": {
    "Address": "Street",
    "Active": "Active",
    "Expired": "Expired",
    "Afgiftedatum": "Issue date",
    "Assigned date": "Date of assignment",
    "Assigned percentage": "Allocation Percentage",
    "Assigned time": "Assignment time",
    "AW35 needed": "AW35 needed",
    "Approval inherited": "Inherited",
    "AW35Statuses": {
      "Approved": "Report approved",
      "Downloaded": "Waiting for Vecozo's response",
      "Rejected": "Notification rejected - Click to open the return message and view the errors",
      "Unknown": "Report created"
    },
    "AanvraagInstellingen": "Assignments",
    "AddToewijzing": "Add assignment",
    "RemoveToewijzing": "Remove assignment",
    "Show current and superseded": "Show current and superseded assignments",
    "Show current only": "Show current assignments only",
    "Superseded": "Superseded",
    "Toewijzing": "Assignment",
    "AW39Types": {
      "SelectType": "Select message type",
      "Mutation": "Mutation",
      "AAT": "AAT (Request for Alternative Assignment)"
    },
    "BerichtTypes": {
      "AW33": "Allocation of care (AW33)",
      "AW34": "Return - Allocation of care (AW34)",
      "AW35": "Notification of the start of long-term care (AW35)",
      "AW35_RECALL": "Recall notification of commencement of long-term care (AW35)",
      "AW36": "Return - Notification of the start of long-term care (AW36)",
      "AW39": "Termination/change in long-term care (AW39)",
      "AW39_RECALL": "Recall termination/mutation of long-term care (AW39)",
      "AW310": "Return - Termination/mutation of long-term care (AW310)",
      "AW317": "Waitlist Message (AW317)",
      "AW318": "Return - Waitlist Message (AW318)",
      "AW319": "Declaration message (AW319)",
      "AW320": "Return - Declaration message (AW320)",
      "CA317": "Initiation of CAK care (CA317)",
      "CA318": "Return - Start of care CAK (CA318)",
      "CA319": "Change in CAK care (CA319)",
      "CA320": "Return - Change care CAK (CA320)",
      "ZK31": "File transfer client ZK-ZK (ZK31)",
      "ZK32": "Return - File transfer client ZK-ZK (ZK32)",
      "ZK33": "Allocation of care ZK-ZK (ZK33)",
      "ZK34": "Return - Allocation of care ZK-ZK (ZK34)",
      "ZK35": "Start of care ZK-ZK (ZK35)",
      "ZK36": "Return - Start of care ZK-ZK (ZK36)",
      "ZK39": "Change care ZK-ZK (ZK39)",
      "ZK310": "Return - Change care ZK-ZK (ZK310)"
    },
    "Besluitnummer": "Decision number",
    "Bsn": "BSN number",
    "Cancel Melding aanvang zorg (AW35)": "Cancel notification start of care (AW35)",
    "Cancel mutatie zorg (AW39)": "Cancel notification of mutation/termination of care (AW39)",
    "Cancel request": "Cancel request",
    "Category": "Category",
    "City": "Toponym",
    "Client": {
      "Beperking": "Constraint",
      "Beperkingen": {
        "1": "Social self-reliance (1)",
        "2": "Mobility (2)",
        "3": "Personal care (3)",
        "4": "Domestic life (4)",
        "5": "Social relations and social life (5)",
        "6": "Participation in learning, working (6)"
      },
      "BeperkingScore": "Throttling score",
      "BurgerlijkeStaatOptions": {
        "1": "Unmarried",
        "2": "Married",
        "3": "Divorced",
        "4": "Widowed",
        "5": "Registered partner",
        "6": "Divorced registered partner",
        "7": "Registered partner left behind",
        "9": "Unmarried not a registered partner"
      },
      "Client": "{Bsn}",
      "Contact": "Contact | Contacts",
      "FinancieringOptions": {
        "1": "Wlz",
        "2": "Wlz, formerly Wlz-indicatable",
        "3": "Subsidies",
        "4": "Otherwise"
      },
      "GeindiceerdeZorgzwaartePakketten": "Indicated care intensity packages",
      "GeslachtOptions": ["Unknown / Not Specified", "Husband", "Wife"],
      "Indication": "Indication",
      "LeefeenheidOptions": {
        "1": "Lives alone and independent (single-person household) (1)",
        "2": "Lives as a child with parent(s) in parental home (2)",
        "3": "Has an independent household with only a partner (3)",
        "4": "Has a household with a partner and children living at home (4)",
        "5": "Has an adult household with 1 or more children (5)",
        "6": "Another multi-person household (6)",
        "7": "Lives in a residential care facility (7)",
        "9": "Unknown (9)"
      },
      "LeveringsstatusOptions": {
        "1": "Active waiting",
        "2": "Wait for preference",
        "3": "Wait as a precaution",
        "4": "In care",
        "5": "End of demand for care",
        "6": "Urgent placement",
        "7": "Active placement"
      },
      "LeveringsvormOptions": {
        "2": "Personal budget (PGB) (2)",
        "4": "Lodging (4)",
        "5": "Full package at home (VPT) (5)",
        "7": "Modular Package Home (MPT) (7)",
        "8": "Part-time residence (DTV) (8)",
        "9": "Wrong bed (VKB) (9)"
      },
      "MutatiecodeOptions": {
        "12": "Client does not want the care or support (yet) (12)",
        "17": "Transfer (there is a notification of the start of care or support) (17)",
        "18": "Provider is not yet able to provide the care or support (18)",
        "19": "Care or support delivery has ended - close allocation (19)",
        "20": "Provision of care or support has ended - keep allocation (20)",
        "21": "Transfer of assignment (there is no notification of the start of care or support) (21)"
      },
      "NaamgebruikOptions": {
        "1": "Own name (1)",
        "2": "Name of spouse or registered partner or alternative name (2)",
        "3": "Name of spouse or registered partner followed by own name (3)",
        "4": "Own name followed by name of spouse or registered partner (4)",
        "5": "Pseudonym (5)",
        "6": "Non-natural person (6)"
      },
      "Relatie": "Relationship | Relationships",
      "ScoreBeperkingen": {
        "0": "Can do this activity yourself, no help from someone else is needed (0)",
        "1": "Can do it yourself, but someone else has to watch or encourage (1)",
        "2": "Can only do this with a lot of effort/someone else has to help (2)",
        "3": "Can't do this independently/someone else has to take over (3)",
        "9": "Not rated (9)"
      },
      "SoortIndicatieContactOptions": {
        "01": "PRD address",
        "02": "Correspondence address",
        "03": "Residence address",
        "04": "Temporary residence address"
      },
      "SoortIndicatieOptions": {
        "1": "CIZ indication",
        "2": "BJZ indication",
        "3": "CIZ/BJZ indication",
        "4": "Experiments"
      },
      "SoortRelatieOptions": {
        "10": "Parent",
        "11": "Guardian",
        "12": "Partner/spouse",
        "13": "Foster parent",
        "14": "Administrator",
        "15": "Mentor",
        "16": "Son/Daughter",
        "17": "Relative",
        "18": "Family member",
        "19": "Neighbour",
        "20": "Friend/acquaintance",
        "21": "Client supporter",
        "22": "General practitioner",
        "23": "Heirs of",
        "24": "Employer",
        "25": "District coach",
        "03": "Curator (legal)",
        "04": "Financial (authorized)",
        "05": "Financial (assessment)",
        "06": "Living unit",
        "07": "Rescuer",
        "08": "Specialist",
        "09": "Otherwise"
      },
      "SoortToewijzingOptions": {
        "1": "Regular",
        "3": "Bridging",
        "5": "Administrative"
      },
      "StatusAanleveringOptions": {
        "1": "First delivery (1)",
        "2": "Changed delivery (2)",
        "3": "Removal of delivery (3)",
        "9": "Not applicable (unchanged) (9)"
      },
      "Stoornis": "Disorder",
      "StoornisScore": "Disorder score",
      "Stoornissen": {
        "COD923": {
          "10": "Diseases of the respiratory system (10)",
          "11": "Diseases of the digestive system (11)",
          "12": "Diseases of skin and subcutis (12)",
          "13": "Diseases of bone muscle tissue and connective tissue (13)",
          "14": "Diseases of the genitourinary system (14)",
          "15": "Pregnancy, childbirth and childbirth (15)",
          "16": "Disorders with perinatal origin (16)",
          "17": "Congenital abjects, malformations and chromos. afw. (17)",
          "18": "Other symptoms, findings, results (18)",
          "19": "Injuries and consequences of external causes (19)",
          "20": "External causes of illness and death (20)",
          "21": "Health factors influencing health (21)",
          "01": "Bep. infectious diseases and parasitic diseases (01)",
          "02": "Neoplasms (= tumors) (02)",
          "03": "Diseases of blood and immune system (03)",
          "04": "Endocrine diseases and nutritional/nutrient disorders (04)",
          "05": "Mental disorders and behavioral disorders (05)",
          "06": "Diseases of the nervous system (06)",
          "07": "Diseases of the eye and adnexus (07)",
          "08": "Diseases of the ear and mastoid process (08)",
          "09": "Diseases of the cardiovascular system (09)"
        },
        "COD924": {
          "b117_0": "Low gifted/difficult to learn (b117.0)",
          "b117_1": "Mild intellectual disability / very difficult to learn (b117.1)",
          "b117_2": "Moderate intellectual disability (b117.2)",
          "b117_3": "Severe intellectual disability (b117.3)",
          "b117_4": "Very severe intellectual disability (b117.4)",
          "b117_9": "Not Specified (b117.9)"
        },
        "COD925": {
          "b110": "Consciousness (b110)",
          "b114": "Orientation (b114)",
          "b117": "Intellectual functions (b117)",
          "b122": "Global psychosocial functions (b122)",
          "b126": "Temperament and personality (b126)",
          "b130": "Energy and Drives (b130)",
          "b134": "Sleep (b134)",
          "b139": "General mental functions (not specified) (b139)",
          "b140": "Attention (b140)",
          "b144": "Memory (b144)",
          "b147": "Psychomotor functions (b147)",
          "b152": "Vote (b152)",
          "b156": "Perception (b156)",
          "b160": "Thinking (b160)",
          "b164": "Higher cognitive functions (b164)",
          "b199": "Mental functions (not specified) (b199)",
          "b210": "Visual Functions (b210)",
          "b215": "Functions of Eye-Related Structures (B215)",
          "b220": "Sensations of the eye and relatives (b220)",
          "b229": "Visual and related functions (not specified) (b229)",
          "b230": "Hearing functions (b230)",
          "b235": "Vestibular functions (b235)",
          "b270": "Sensory functions (pain and other stimuli) (b270)",
          "b310": "Voice (b310)",
          "b320": "Articulation (b320)",
          "b340": "Alternative forms of voice use (b340)",
          "b410": "Heart functions (b410)",
          "b415": "Functions of blood vessels (b415)",
          "b420": "Blood pressure (b420)",
          "b430": "Functions of Hematology System (b430)",
          "b435": "Functions of the immune system (b435)",
          "b440": "Breathing (b440)",
          "b455": "Exercise tolerance (b455)",
          "b469": "Other functions heart / vessels / breathing (b469)",
          "b510": "Food intake (b510)",
          "b515": "Digestion (b515)",
          "b525": "Defecation (b525)",
          "b535": "Sensations of the digestive system (b535)",
          "b539": "Functions of the digestive system (not specified) (b539)",
          "b540": "General metabolic functions (b540)",
          "b545": "Water, mineral and electrolyte balance (b545)",
          "b550": "Thermoregulatory functions (b550)",
          "b555": "Functions of endocrine glands (b555)",
          "b559": "Metabolic/endocular functions (not specified) (b559)",
          "b610": "Production and storage of urine (b610)",
          "b620": "Functions related to urination (b620)",
          "b639": "Urinary functions (not specified) (b639)",
          "b679": "Genital and reproductive functions (b679)",
          "b710": "Joint mobility (b710)",
          "b715": "Stability of joints (b715)",
          "b729": "Functions of joints and bones (b729)",
          "b749": "Muscle functions (b749)",
          "b750": "Motor reflex functions (b750)",
          "b755": "Involuntary Motion Reactions (b755)",
          "b760": "Random Movement Control (b760)",
          "b765": "Involuntary movements (b765)",
          "b789": "Motion Functions (Not Specified) (b789)",
          "b849": "Functions of skin (b849)",
          "b869": "Functions of hair and nails (b869)"
        },
        "COD926": {
          "b210_1": "Mild visual impairment (b210.1)",
          "b210_2": "Moderate vision impairment (b210.2)",
          "b210_3": "(Very) severe vision impairment (b210.3)",
          "b210_4": "(Functional) blindness (b210.4)",
          "b210_9": "Not specified (b210.9)"
        },
        "COD927": {
          "b230_1": "Mild hearing impairment (b230.1)",
          "b230_2": "Moderate hearing impairment (b230.2)",
          "b230_3": "(Very) severe hearing impairment (b230.3)",
          "b230_4": "Deafness (complete) (b230.4)",
          "b230_9": "Not specified (b230.9)"
        },
        "DiagnoseCodelijstMappingStoornissen": {
          "014": "COD923",
          "019": "COD923",
          "021": "COD925",
          "022": "COD924",
          "023": "COD926",
          "024": "COD927"
        },
        "DiagnoseCodelijstOptions": {
          "014": "Classification of diseases (ZIN/ICD-10) (014)",
          "019": "Diagnostic and statistical manual of mental disorders IV (DSM-IV) (019)",
          "021": "International Classification of Functioning (ICF) (021)",
          "022": "IQ (022)",
          "023": "Visual (023)",
          "024": "Auditory (024)"
        },
        "DiagnoseSubcodelijstOptions": {
          "10": "Axis IV (10)",
          "11": "Axis V (11)",
          "12": "Visual (12)",
          "13": "Auditory (13)",
          "01": "Mental (01)",
          "02": "Sensory (02)",
          "03": "Physical (03)",
          "04": "1st Condition (04)",
          "05": "2nd Disorder (05)",
          "06": "3rd Disorder (06)",
          "07": "Axis I (07)",
          "08": "Axis II (08)",
          "09": "Axis III (09)"
        },
        "GrondslagOptions": {
          "01": "Somatic disease/disorder (01)",
          "02": "Psychogeriatric Illness/Disorder (02)",
          "03": "Psychiatric disorder, mental disorder (03)",
          "04": "Physical disability (functional impairment) (04)",
          "05": "Intellectual disability (functional disorder) (05)",
          "06": "Sensory disability (functional impairment) (06)",
          "07": "Psychosocial problems (07)"
        },
        "PrognoseOptions": {
          "1": "Prospect of full recovery within 1 year (1)",
          "2": "Prospect of partial recovery/improvement within 1 year (2)",
          "3": "The state of health remains the same (3)",
          "4": "A deterioration is expected within 1 year (4)",
          "5": "Unknown; Forecast not available or not possible (5)"
        },
        "ScoreStoornissen": {
          "0": "No problem/no help needed from others (0)",
          "1": "Problem: occasionally need help, supervision or guidance (1)",
          "2": "Problem: often help, supervision or guidance needed (2)",
          "3": "Problem: continuous help, supervision or guidance needed (3)",
          "9": "Not rated (9)"
        },
        "VraagStoornissen": {
          "0101": "Orientation disorder - Orientation in time: knowing what day it is, etc. (0101)",
          "0102": "Orientation disorder - Orientation to place: knowing where you are (0102)",
          "0103": "Orientation disorder - Orientation in space: finding your way around the house and surroundings (0103)",
          "0104": "Orientation disorder - Orientation in person: knowing who you are, who others are (0104)",
          "0201": "Psychosocial functions - Concentration (0201)",
          "0202": "Psychosocial Functions - Memory and Thinking (0202)",
          "0203": "Psychosocial functions - Perception of environment (-distorted) (0203)",
          "0204": "Psychosocial functions - Motivation (lethargic, no initiative) (0204)",
          "0301": "Motor Functioning - Use of Right Arm, Left Arm (0301)",
          "0302": "Motor Functioning - Use of Right Hand, Left Hand (0302)",
          "0303": "Motor functioning - Use of right leg, left leg (0303)",
          "0304": "Motor functioning - Use of right foot, left foot (0304)",
          "0305": "Motor functioning - Maintaining the main balance (0305)",
          "0306": "Motor functioning - Maintaining trunk balance (0306)",
          "0401": "Problem Behavior/Safety - Self-injurious or self-injurious behavior (0401)",
          "0402": "Problem behavior/safety - Verbal aggressive behavior (0402)",
          "0403": "Problem behavior/safety - Physically aggressive behavior (0403)",
          "0404": "Problem behavior/safety - Destructive behavior (vandalism, arson, stealing) (0404)",
          "0405": "Problem behavior/safety - Manipulative behavior (obstruction, ignoring, walking away) (0405)",
          "0406": "Problem behavior/safety - Compulsive behavior (not wanting to speak, eat, move) (0406)",
          "0407": "Problem behaviour/safety - Transgressive sexual behaviour (0407)",
          "0501": "Addiction problems - Use of soft drugs (0501)",
          "0502": "Addiction problems - Use of hard drugs (0502)",
          "0503": "Addiction problems - Use of alcohol (0503)",
          "0504": "Addiction problems - Addiction problems other (0504)",
          "0601": "Psychosocial well-being - Being anxious (0601)",
          "0602": "Psychosocial well-being - Being despondent (\"depressed\") (0602)",
          "0603": "Psychosocial well-being - Interest and involvement (0603)",
          "0604": "Psychosocial well-being - Lack of personal relationships (0604)",
          "0605": "Psychosocial well-being - Lack of valued social roles (0605)"
        }
      },
      "ToegewezenZorgzwaartePakketten": "Assigned care intensity packages",
      "VoorkeurClientOptions": {
        "2": "Personal budget (PGB) (2)",
        "3": "Care at home (not specified) (3)",
        "4": "Lodging (4)",
        "5": "Full package at home (VPT) (5)",
        "6": "Combination PGB/MPT (6)",
        "7": "Modular Package Home (MPT) (7)",
        "8": "combination VPT/PGB (8)",
        "9": "combination Accommodation/PGB (9)",
        "10": "Part-time residence (DTV) (10)"
      },
      "VraagBeperkingen": {
        "0101": "Social self-reliance - Solving problems, making decisions and assessing consequences (101)",
        "0102": "Social self-reliance - Initiating + performing simple tasks (e.g. making food, doing the laundry) (102)",
        "0103": "Social self-reliance - Initiating + performing more complex tasks (e.g. work rhythm) (103)",
        "0104": "Social self-reliance - Arranging daily routine: structure in daily schedule (104)",
        "0105": "Social self-reliance - Daily activities: planning/carrying out activities (105)",
        "0106": "Social self-reliance - Ability to read, write and count (106)",
        "0107": "Social self-reliance - Managing money yourself, knowing how to buy and pay for something (107)",
        "0108": "Social self-reliance - Handling all kinds of administrative matters yourself (108)",
        "0109": "Social self-reliance - Getting by using public transport (109)",
        "0110": "Social self-reliance - Getting by in shops, post office, bank, etc. (110)",
        "0111": "Social self-reliance - Communication: understanding what others are saying (111)",
        "0112": "Social self-reliance - Communication: making oneself understandable to others (112)",
        "0113": "Social self-reliance - Communication: having a conversation (113)",
        "0114": "Social self-efficacy - Using communication tools (phone, computer, etc.) (114)",
        "0201": "Mobility - Changing body position (getting up from chair, kneeling and standing up) (201)",
        "0202": "Mobility - Maintaining body position (standing upright; sitting in chair) (202)",
        "0203": "Mobility - Lifting and carrying lighter objects (e.g. picking up cups) (203)",
        "0204": "Mobility - Lifting and carrying heavier objects (e.g. putting child to bed) (204)",
        "0205": "Mobility - Combined movements with legs/feet (e.g. cycling) (205)",
        "0206": "Mobility - Making fine hand movements (e.g. counting money, pressing keys) (206)",
        "0207": "Mobility - Making gross hand and arm movements (pushing, pulling, catching) (207)",
        "0208": "Mobility - Moving indoors, without assistance or aids (208)",
        "0209": "Mobility - Going up and down stairs, without assistance or aids (209)",
        "0210": "Mobility - Walking short distances: maximum kilometres (210)",
        "0211": "Mobility - Getting around outdoors (> kilometer) without assistance/aids (211)",
        "0212": "Mobility - Getting around using assistive devices (walker, wheelchair, etc.) (212)",
        "0213": "Mobility - Using your own means of transport (bicycle, car) (213)",
        "0214": "Mobility - Using public transport (train, bus) (214)",
        "0301": "Personal care - Washing: parts of body or whole body (301)",
        "0302": "Personal Care - Dressing: Dressing and Undressing (302)",
        "0303": "Personal Care - Getting in and out of bed (303)",
        "0304": "Personal care - Getting around in sitting or lying position (304)",
        "0305": "Personal care - Going to the toilet and cleaning yourself (305)",
        "0306": "Personal care - Food and beverages (306)",
        "0307": "Personal Care - Personal Care for Teeth, Hair, Nails, Skin (307)",
        "0308": "Personal care - Self application of a prosthesis (308)",
        "0309": "Personal care - Taking care of your own health (healthy food, etc.) (309)",
        "0401": "Household Life - Shopping for Everyday Life (401)",
        "0402": "Domestic life - Preparing meals: bread meal (402)",
        "0403": "Housekeeping - Preparing meals: hot meal (403)",
        "0404": "Domestic life - Light cleaning in the house; Room tidying (404)",
        "0405": "Housekeeping - House cleaning, vacuuming, toilet/bathroom cleaning (405)",
        "0406": "Housekeeping - Washing clothes/linen (\"doing the laundry\") (406)",
        "0407": "Household - Using household appliances (washing machine, vacuum cleaner, iron) (407)",
        "0408": "Household life - Keeping household items in order (clothes, plants, appliances) (408)",
        "0409": "Household Life - Helping Others in the Household with Self-Care (409)",
        "0410": "Household Life - Helping Others Prepare Meals, Eat, etc. (410)",
        "0411": "Household life - Daily household organization (411)",
        "0501": "Social Relationships and Social Life - Maintaining Relationships with Family (501)",
        "0502": "Social Relationships and Social Life - Building Contacts with Others Independently (502)",
        "0503": "Social relationships and social life - Maintaining independent contacts with others (friends) (503)",
        "0504": "Social relations and social life - Independent participation in clubs and associations (504)",
        "0505": "Social relations and social life - Leisure activities outside the home: sports, theatre, cafés, etc. (505)",
        "0506": "Social relations and social life - Independent access to general facilities (such as shops, library) (506)",
        "0601": "Participation in education, work - Participation in ordinary childcare (601)",
        "0602": "Participation in education, work - Attending school in mainstream education (602)",
        "0603": "Participation in education, work - School attendance in special education (603)",
        "0604": "Participation in education, work - Participation in after-school or out-of-school care (604)",
        "0605": "Participation in education, work - PARENTS of the applicant: raising the child (developing skills) (605)",
        "0606": "Participation in education, work - PARENTS of the inquirer: providing daily structure to the growing child (606)",
        "0607": "Participation in education, work - Seeking and getting a paid job (607)",
        "0608": "Participation in education, work - Performing a daily job, maintaining a fixed work rhythm (608)",
        "0609": "Participation in education, work - Paid employment: full-time (609)",
        "0610": "Participation in education, work - Paid employment: part-time (610)",
        "0611": "Participation in education, work - Doing unpaid work in voluntary groups (611)"
      },
      "ZorgkantoorOptions": {
        "5501": "Care Office Groningen (5501)",
        "5502": "Care Office Friesland (5502)",
        "5503": "Zorgkantoor Drenthe (5503)",
        "5504": "Care office Zwolle (5504)",
        "5505": "Zorgkantoor Twente (5505)",
        "5506": "Zorgkantoor Apeldoorn, Zutphen en omstreken (5506)",
        "5507": "Zorgkantoor Arnhem (5507)",
        "5508": "Care Office Nijmegen (5508)",
        "5509": "Zorgkantoor Utrecht (5509)",
        "5510": "Care Office Flevoland (5510)",
        "5511": "Care office 't Gooi (5511)",
        "5512": "Care Office North Holland North (5512)",
        "5513": "Care Office Kennemerland (5513)",
        "5514": "Care office Zaanstreek/Waterland (5514)",
        "5515": "Amsterdam Care Office (5515)",
        "5516": "Zorgkantoor Amstelland en De Meerlanden (5516)",
        "5517": "Zorgkantoor Zuid-Holland Noord (5517)",
        "5518": "Zorgkantoor Haaglanden (5518)",
        "5519": "Zorgkantoor Delft Westland Oostland (5519)",
        "5520": "Zorgkantoor Midden-Holland (5520)",
        "5521": "Rotterdam Care Office (5521)",
        "5523": "Zorgkantoor Zuid-Hollandse Eilanden (5523)",
        "5524": "Zorgkantoor Waardenland (5524)",
        "5525": "Zeeland Care Office (5525)",
        "5526": "Zorgkantoor West-Brabant (5526)",
        "5527": "Zorgkantoor Midden-Brabant (5527)",
        "5528": "Care Office Northeast Brabant (5528)",
        "5529": "Zorgkantoor Zuidoost-Brabant (5529)",
        "5530": "Care Office North and Central Limburg (5530)",
        "5531": "Zorgkantoor Zuid-Limburg (5531)",
        "5532": "Zorgkantoor Midden-IJssel (5532)",
        "5533": "Zorgkantoor Friesland (5533)"
      },
      "ZzpOptions": {
        "190": "9VV A: Geriatric rehabilitation care (190)",
        "191": "9VV B: Recovery-oriented treatment with nursing and care (191)",
        "750": "1VV: Sheltered living with some guidance (750)",
        "751": "2VV: Sheltered living with guidance and care (751)",
        "752": "3VV: Sheltered living with guidance and intensive care (752)",
        "753": "4VV: Sheltered living with intensive guidance and extensive care (753)",
        "754": "5VV: Sheltered living with intensive dementia care (754)",
        "755": "6VV: Sheltered housing with intensive care and nursing (755)",
        "756": "7VV: Sheltered housing with very intensive care, due to specific conditions, with an emphasis on guidance (756)",
        "757": "8VV: Sheltered housing with very intensive care, due to specific conditions, with an emphasis on care/nursing (757)",
        "758": "9VV: Recovery-oriented treatment with nursing and care (758)",
        "759": "10VV: Sheltered accommodation with intensive palliative-terminal care (759)",
        "760": "1GGZ C: Assisted living (760)",
        "762": "2GGZ C: Structured sheltered living with extensive guidance (762)",
        "764": "3GGZ C: Sheltered housing with intensive supervision (764)",
        "766": "4GGZ B: Continued stay with intensive guidance and care (766)",
        "768": "5GGZ B: Continued stay with intensive guidance and behavioural regulation (768)",
        "770": "6GGZ B: Continued stay with intensive supervision and intensive nursing and care (770)",
        "772": "7GGZ B: Secure continued stay due to extreme behavioural problems with very intensive supervision (772)",
        "780": "1LVG: Living with some treatment and guidance (780)",
        "781": "2LVG: Living with treatment and guidance (781)",
        "782": "3LVG: Living with intensive treatment and guidance, small group (782)",
        "783": "4LVG: Living with very intensive treatment and guidance (783)",
        "784": "5LVG: Enclosed living with very intensive treatment and guidance (784)",
        "790": "1SGLVG: Treatment in an SGLVG treatment centre (790)",
        "800": "1VG: Living with some guidance (800)",
        "802": "2VG: Living with guidance (802)",
        "804": "3VG: Living with guidance and care (804)",
        "806": "4VG: Living with guidance and intensive care (806)",
        "808": "5VG: Living with intensive guidance and intensive care (808)",
        "810": "6VG: Living with intensive guidance, care and behavioural regulation (810)",
        "812": "7VG: (Private) living with very intensive guidance, care and behavioural regulation (812)",
        "814": "8VG: Living with guidance and full care and nursing (814)",
        "820": "1LG: Living with some guidance and some care (820)",
        "822": "2LG: Living with guidance and some care (822)",
        "824": "3LG: Living with some guidance and care (824)",
        "826": "4LG: Living with guidance and care (826)",
        "828": "5LG: Living with guidance and intensive care (828)",
        "830": "6LG: Living with intensive supervision and intensive care (830)",
        "832": "7LG: Living with very intensive supervision and very intensive care (832)",
        "840": "1ZGvis: Living with some guidance and some care (840)",
        "842": "2ZGvis: Living with guidance and some care (842)",
        "844": "3ZGvis: Living with intensive guidance and care (844)",
        "846": "4ZGvis: Living with intensive guidance and intensive care (846)",
        "848": "5ZGvis: Living with very intensive guidance and very intensive care (848)",
        "850": "1ZGaud: Living with guidance and some care (850)",
        "852": "2ZGaud: Living with intensive guidance and care (852)",
        "854": "3ZGaud: Living with intensive guidance and intensive care (854)",
        "856": "4ZGaud: Living with intensive guidance and some care (856)",
        "860": "1GGZ B: Continued stay with management (860)",
        "862": "2GGZ B: Continued stay with structure and extensive guidance (862)",
        "864": "3GGZ B: Continued stay with intensive supervision (864)",
        "866": "4GGZ C: Structured sheltered living with intensive guidance and care (866)",
        "868": "5GGZ C: Sheltered housing with intensive guidance and behavioural regulation (868)",
        "870": "6GGZ C: Sheltered housing with intensive supervision and intensive nursing and care (870)",
        "880": "1GGZ W: Living with intensive supervision (880)",
        "882": "2GGZ W: Living with intensive guidance and care (882)",
        "884": "3GGZ W: Living with intensive guidance and behavioral regulation (884)",
        "886": "4GGZ W: Living with intensive guidance and intensive nursing and care (886)",
        "888": "5GGZ W: Secure Living due to extreme behavioral problems with very intensive guidance (888)",
        "996": "Wlz Indicatable (996)",
        "997": "PGB: ZZP code to be used only for start and stop PGB Wlz-inindicaerenbaren aan CAK (997)",
        "998": "ZZPX: Indefinite care intensity package (998)",
        "999": "ZZP0: Partner stay (999)"
      }
    },
    "Clients": "Client(s)",
    "Clients processed": {
      "Client successfully added text": "The client {fullName} has been successfully processed.",
      "Clients successfully added text": "The clients have been successfully processed.",
      "Following steps": {
        "Add attendant": "A point of contact is assigned",
        "Add client care": "The care per location is set up",
        "Add representative": "A representative is assigned"
      },
      "Following steps text": "If new clients have been added, it is important that the following cases are set up for all clients:"
    },
    "Comments": "Comment",
    "Coordinator zorg thuis": "Coordinator care at home",
    "Created": "Created",
    "Credit item fail": "Error crediting deliverables.",
    "Credit item success": "Deliverables successfully credited.",
    "Credit items": "Credit items",
    "Date of birth": "Date of Birth",
    "Delivery type": "Delivery form",
    "Diagnosis": "Diagnosis",
    "DiagnosisSubcode": "Diagnosis subcode",
    "Dialog confirm cancel message": {
      "Message": "Are you sure you want to recall this message?",
      "Title": "Recall message"
    },
    "Dialog confirm create declaration credit": {
      "Message": "The is a concept declaration for this period. Continuing will remove this concept! Are you sure you want to continue?",
      "Title": "Create credit"
    },
    "Dialog confirm open credit message": {
      "Message": "Credit has been successfully created. Would you like to open the corresponding AW319 message?",
      "Title": "Succesvol created"
    },
    "Dialog confirm open message": {
      "Message": "The message has been successfully imported. Do you want to open it now?",
      "Title": "Successfully imported"
    },
    "Dialog confirm process message": {
      "Conflict message": "There is still {count} attendance registration after the care end date ({endDate}). Update this registration and try again. | There are still {count} attendance registrations after the care end date ({endDate}). Update these registrations and try again.",
      "Message": "Are you sure you want to process this message?",
      "Retry": "Try again",
      "Title": "Process message"
    },
    "Direction": "Direction",
    "DirectionOptions": {
      "in": "Incoming",
      "out": "Outgoing"
    },
    "Disorder": "Clinical picture/disorder",
    "Download item fail": "Message could not be downloaded.",
    "Download item success": "Message downloaded successfully.",
    "Einddatum": "Finish",
    "Errors": {
      "AAT_ONLY_POSSIBLE_FOR_OWN_ZZPS": "AAT is only possible for assigned ZZPs.",
      "AT_LEAST_ONE_ASSIGNMENT_REQUIRED": "At least one assignment must be specified.",
      "AW33_PROCESSING_FAILED": "Processing of the AW33 message failed.",
      "AW35_START_AFTER_ASSIGNMENT": "The AW35 start date is after the assigned care package end date.",
      "AW35_START_BEFORE_ASSIGNMENT": "The AW35 start date is before the assigned care package start date.",
      "AW36_CONTAINS_ERRORS": "Vecozo rejected the start-of-care notification. The return codes were stored with the message.",
      "AW36_PROCESSING_FAILED": "Processing of the AW36 message failed.",
      "AW319_PARSE_FAIL": "Failed to parse the AW319 message or it contains invalid data.",
      "AW320_PROCESSING_FAILED": "Processing of the AW320 message failed.",
      "AW320_CLIENT_BSN_MISSING": "A client record in the AW320 has no citizen service number.",
      "AW320_ALREADY_IMPORTED": "This AW320 has already been imported. Use Try again on the existing message.",
      "AW320_COMMENT_REFERENCE_MISSING": "An error code in an AW320 comment record does not refer to a detail record.",
      "AW320_CLIENT_SET_MISMATCH": "The AW320 does not contain all expected client records.",
      "AW320_DECLARATION_MISMATCH": "The AW320 does not belong to the matched declaration.",
      "AW320_DUPLICATE_CLIENT": "The AW320 contains a duplicate client record.",
      "AW320_DUPLICATE_PERFORMANCE": "The AW320 contains a duplicate performance reference.",
      "AW320_INVOICE_NUMBER_MISSING": "The AW320 has no invoice number.",
      "AW320_INVALID_STRUCTURE": "The AW320 has an invalid fixed-record structure or incorrect record counts.",
      "AW320_PERFORMANCE_BSN_MISMATCH": "A performance citizen service number in the AW320 does not match the declaration.",
      "AW320_PERFORMANCE_BSN_MISSING": "A performance record in the AW320 has no citizen service number.",
      "AW320_PERFORMANCE_REFERENCE_MISSING": "A performance record in the AW320 has no reference.",
      "AW320_PERFORMANCE_SET_MISMATCH": "The AW320 does not contain all expected performance records.",
      "AW320_UNKNOWN_CLIENT": "The AW320 contains a client that is not part of the declaration.",
      "AW320_UNKNOWN_COMMENT_TARGET": "An AW320 comment record refers to an unknown detail record.",
      "AW320_UNKNOWN_PERFORMANCE": "The AW320 contains a performance reference that is not part of the declaration.",
      "CANNOT_AAT_TO_OWN_AGB": "Assignment to own institution is not allowed.",
      "CANCELLATION_ALREADY_REQUESTED": "A withdrawal message is already pending for this message.",
      "CREDIT_DECLARATION_GENERAL_ERROR": "The credit declaration cannot be created due to a technical error.",
      "END_DATE_CANNOT_BE_BEFORE_START_DATE": "The end date cannot be before the start date.",
      "EXPORT_ONLY_AW319": "Only AW319 messages can be exported.",
      "FAILED_GENERATE_AW35": "Failed to generate the AW35 message.",
      "FILE_NOT_FOUND": "The specified file could not be found.",
      "FIXED_WIDTH_MESSAGE_NOT_AW320": "The provided file is not a valid AW320 message.",
      "GENERAL_EXCEPTION": "An unexpected error occurred during processing.",
      "GENERIC": "An unknown error occurred.",
      "INVALID_BASE64": "The provided content is not valid Base64-encoded text.",
      "MALFORMED_XML": "The XML structure is invalid or malformed.",
      "MESSAGE_HAS_NO_ATTACHMENT": "The message has no attachment to process or export.",
      "MESSAGE_ALREADY_HAS_RESPONSE": "A return message has already been processed for this message.",
      "MESSAGE_ALREADY_PROCESSED": "This message has already been processed.",
      "MESSAGE_CANNOT_BE_CANCELLED": "This message can no longer be withdrawn.",
      "MESSAGE_NOT_LATEST": "Only the latest regular message can be withdrawn.",
      "MIXED_DECLARATION_FOR_CREDIT": "All selected prestaties must belong to declarations with the same year, month and period.",
      "NAMESPACE_MISSING": "The XML is missing required namespaces or schema references.",
      "NO_COUNTERPART": "No related message was found}",
      "NO_COUNTERPART_MESSAGE": "The referenced counterpart message could not be found.",
      "NO_FILE_PROVIDED": "No file was provided.",
      "NO_MESSAGE_IDENTIFIER": "The message is missing a required identifier field.",
      "NO_PRESTATIES_FOR_CREDIT": "There are no deliverables selected to credit.",
      "Unique": "A Vecozo message with this message type, identifier, and direction already exists.",
      "Unique_incoming": "This return message is already present",
      "Unique_outgoing": "This application is already available",
      "UNSUPPORTED_IMPORT_MESSAGE_TYPE": "The message type is not supported.",
      "VECOZO_MESSAGE_WRONG_TYPE": "The message type does not match the expected Vecozo message type.",
      "XML_INVALID": "The XML could be parsed but contains invalid or missing fields.",
      "XML_SCHEMA_PARSING_FAILED": "The XSD schema could not be loaded or parsed.",
      "XML_VALIDATION_FAILED": "The XML does not comply with the defined schema."
    },
    "Field": "Kind",
    "File": "File",
    "Financiering type": "Form of financing",
    "First name": "First Name",
    "Gender": "Gender",
    "Generate Melding aanvang zorg (AW35)": "Generate Notification start of care (AW35)",
    "Generate mutatie zorg (AW39)": "Generate notification of mutation/termination of care (AW39)",
    "Generate_aw35 item fail": "Notification request for care (AW35) could not be created.",
    "Generate_aw35 item success": "Notification request for care (AW35) successfully created.",
    "Generate_aw39 item fail": "Notification mutation/termination of care (AW39) could not be created.",
    "Generate_aw39 item success": "Notification mutation/termination of care (AW39) successfully created.",
    "Has response": "Reaction",
    "HasResponseOptions": {
      "Cancelled": "Message rejected or recalled",
      "Created but not exported": "Message created",
      "Exported": "Message exported, waiting for response Vecozo",
      "Received response": "Received a response from Vecozo"
    },
    "House annex": "Addition",
    "House letter": "House letter",
    "House number": "House number",
    "Import message": "Message Import",
    "Import message information": "Only upload XML files supplied by Vecozo!",
    "Ingangsdatum": "Effective date",
    "Initials": "Initials",
    "Instelling": "Institution",
    "Instelling_bestemming": "Transfer to institution",
    "Last name": "Surname",
    "Leveringsstatus": "Delivery status",
    "Leveringsstatus_classificatie": "Delivery status classification",
    "MaritalStatus": "Marital status",
    "MedicalGrounds": "Medical grounds",
    "Message": "Message",
    "Message already processed": "This message has already been processed, only reprocess messages if you are sure it is necessary!",
    "Message contains errors": "The message contains the following errors",
    "Rejected return message": {
      "AW36": "The AW36 has been processed, but Vecozo rejected the corresponding AW35. Review the return codes and, after correcting the cause, create a new AW35 if necessary.",
      "AW310": "The AW310 has been processed, but Vecozo rejected the corresponding AW39. The requested change was not applied. Review the return codes and create a new AW39 after correcting the cause.",
      "Title": "Return message processed: request rejected"
    },
    "Mutation_code": "Mutation code",
    "Mutation_date": "Mutation date",
    "Name": "Name",
    "New": "New data",
    "New item": "New iWlz message",
    "New item fail": "Error creating the new iWlz message.",
    "New item success": "iWlz message successfully added.",
    "Old": "Current data",
    "Postal code": "Zip code",
    "Processed": "Processed",
    "Prognosis": "Prognosis",
    "Question": "Question",
    "RetourCodes": {
      "1156": "Delivery transaction date is incorrect. (1156)",
      "1157": "Care rule has already been closed by a previously received MUT (notification end of care). (1157)",
      "1160": "The mutation date of the MUT (notification of end of care) to be removed is more than a year in the past. (1160)",
      "1161": "The mutation date of the new MUT (notification of end of care) falls after the start date of the second MAZ in a MAZ on MAZ situation. The MUT is part of the first MAZ period that has already been concluded by the MAZ on MAZ situation. (1161)",
      "1162": "Removal of the MUT (notification of end of care) causes concurrence of 3 forms of delivery. (1162)",
      "9002": "Message does not comply with Technical Rule 2 (9002)",
      "9004": "Message does not comply with Technical Rule 4 (9004)",
      "9005": "Message does not comply with Technical Rule 5 (9005)",
      "9006": "Message does not comply with Technical Rule 6 (9006)",
      "9014": "Notice does not comply with Technical Rule 14 (9014)",
      "9015": "Notice does not comply with Technical Rule 15 (9015)",
      "9016": "Notice does not comply with Technical Rule 16 (9016)",
      "9017": "Message does not comply with Technical Rule 17 (9017)",
      "9018": "Message does not comply with constraint CS136. (9018)",
      "9019": "Message does not comply with Technical Rule 19 (9019)",
      "9020": "Notice does not comply with Technical Rule 20 (9020)",
      "9021": "Notice does not comply with Technical Rule 21 (9021)",
      "9037": "Message does not comply with Technical Rule 37 (9037)",
      "9039": "Message does not comply with Technical Rule 39 (9039)",
      "9040": "Message does not comply with Technical Rule 40 (9040)",
      "9041": "Message does not comply with Technical Rule 41 (9041)",
      "9042": "Notice does not comply with Technical Rule 42 (9042)",
      "9046": "Message does not comply with constraint CS137. (9046)",
      "9056": "Notice does not comply with Technical Rule 56 (9056)",
      "9057": "Message does not comply with Technical Rule 57 (9057)",
      "9061": "Notice does not comply with Technical Rule 61 (9061)",
      "9063": "Message does not comply with Technical Rule 63 (9063)",
      "9064": "Notice does not comply with Technical Rule 64 (9064)",
      "9065": "Notice does not comply with Technical Rule 65 (9065)",
      "9066": "Message does not meet condition CD094. (9066)",
      "9069": "Notice does not comply with Technical Rule 69 (9069)",
      "9070": "Notice does not comply with Technical Rule 70 (9070)",
      "9071": "Message does not comply with Technical Rule 71 (9071)",
      "9073": "Notice does not comply with Technical Rule 73 (9073)",
      "9074": "Notice does not comply with Technical Rule 74 (9074)",
      "9078": "Notice does not comply with Technical Rule 78 (9078)",
      "9079": "Notice does not comply with Technical Rule 79 (9079)",
      "9080": "Notice does not comply with Technical Rule 80 (9080)",
      "9091": "Message does not comply with constraint CS138. (9091)",
      "9097": "Message does not comply with constraint CS139. (9097)",
      "9100": "Message does not comply with Technical Rule 100 (9100)",
      "9101": "Message does not comply with Technical Rule 101. (9101)",
      "9103": "Message does not comply with Technical Rule 103 (9103)",
      "9104": "Notice does not comply with Technical Rule 104 (9104)",
      "9106": "Message does not comply with Technical Rule 106 (9106)",
      "9107": "Message does not comply with Technical Rule 107 (9107)",
      "9108": "Message does not comply with Technical Rule 108 (9108)",
      "9109": "Notice does not comply with Technical Rule 109 (9109)",
      "9110": "Message does not comply with Technical Rule 110 (9110)",
      "9111": "Notice does not comply with Technical Rule 111 (9111)",
      "9118": "Notice does not comply with Technical Rule 118 (9118)",
      "9119": "Message does not comply with constraint CS140. (9119)",
      "9120": "Message does not comply with Technical Rule 120 (9120)",
      "9121": "Message does not comply with Technical Rule 121 (9121)",
      "9124": "Message does not comply with Technical Rule 124 (9124)",
      "9125": "Notice does not comply with Technical Rule 125 (9125)",
      "9127": "Message does not comply with Technical Rule 127 (9127)",
      "9128": "Message does not comply with Technical Rule 128 (9128)",
      "9129": "Notice does not comply with Technical Rule 129 (9129)",
      "9130": "Message does not comply with constraint CS141. (9130)",
      "9131": "Message does not comply with Technical Rule 131 (9131)",
      "0001": "Post was rejected for technical reasons. (0001)",
      "0200": "No comment on this message class. (0200)",
      "0233": "Message class is not reviewed. (0233)",
      "0328": "Client has been deregistered due to death. (0328)",
      "0448": "Client cannot be identified. (0448)",
      "0692": "Start date for care with self-employed persons code 880, 882, 884, 886, 888 is before 1 January 2021. (0692)",
      "0693": "Start date for care with ZZP code 997 is after December 31, 2020. (0693)",
      "0694": "Start date for care with ZZP code 996 is after 31 December 2020. (0694)",
      "0695": "Start date for care with DTV delivery form is before 1 January 2020. (0695)",
      "0696": "Start date of care causes concurrence of 3 forms of delivery (0696)",
      "0699": "Delivery start date is incorrect. (0699)",
      "0700": "The start date of the MAZ to be removed is more than a year in the past. (0700)",
      "0701": "The start date of the new MAZ is in an existing MAZ-MUT (notification end of care) period. (0701)",
      "0703": "The start date of the new MAZ has already been provided with a different Form of Delivery. (0703)",
      "0704": "The start date of the new MAZ has already been provided with a different AGB code. (0704)",
      "0705": "The start date of the new MAZ has already been provided with a different ZZP code. (0705)",
      "0706": "The start date of the new MAZ has already been submitted with a different DeliveredHealthcareID. (0706)",
      "0707": "The start date of the new MAZ has already been delivered with delivery form DTV with a different number of Days. (0707)",
      "0800": "DeliveredZorgID has already been supplied with the same data. (0800)",
      "0801": "DeliveredZorgID has already been delivered with a different Form of Delivery. (0801)",
      "0802": "DeliveredZorgID has already been supplied with a different AGB code. (0802)",
      "0803": "DeliveredHealthcareID has already been supplied with a different ZZP code. (0803)",
      "0804": "DeliveredZorgID has already been supplied with delivery form DTV with a different number of Days. (0804)",
      "D004": "Message does not meet condition CD004. (D004)",
      "D005": "Message does not meet condition CD005. (D005)",
      "D007": "Message does not meet condition CD007. (D007)",
      "D009": "Message does not meet condition CD009. (D009)",
      "D016": "Message does not meet condition CD016. (D016)",
      "D017": "Message does not meet condition CD017. (D017)",
      "D020": "Message does not meet condition CD020. (D020)",
      "D025": "Message does not meet condition CD025. (D025)",
      "D029": "Notice does not comply with Technical Rule 132. (D029)",
      "D034": "Message does not meet condition CD034. (D034)",
      "D036": "Message does not meet condition CD036. (D036)",
      "D040": "Message does not meet condition CD040. (D040)",
      "D047": "Message does not meet condition CD047. (D047)",
      "D048": "Message does not meet condition CD048. (D048)",
      "D050": "Message does not meet condition CD050 (D050)",
      "D052": "Message does not meet condition CD052 (D052)",
      "D070": "Message does not meet condition CD070 (D070)",
      "D072": "Message does not meet condition CD072 (D072)",
      "D073": "Message does not meet condition CD073 (D073)",
      "D074": "Message does not meet condition CD074 (D074)",
      "D090": "Message does not meet condition CD090 (D090)",
      "D091": "Message does not meet condition CD091 (D091)",
      "D097": "Message does not meet condition CD097 (D097)",
      "D098": "Message does not meet condition CD098. (D098)",
      "S002": "Message does not comply with constraint CS002. (S002)",
      "S003": "Message does not comply with constraint CS003. (S003)",
      "S012": "Message does not comply with constraint CS012. (S012)",
      "S014": "Message does not comply with constraint CS014. (S014)",
      "S023": "Notice does not comply with Technical Rule 134. (S023)",
      "S035": "Message does not comply with constraint CS035. (S035)",
      "S050": "Message does not comply with constraint CS050. (S050)",
      "S058": "Message does not comply with constraint CS058. (S058)",
      "S062": "Message does not comply with constraint CS062. (S062)",
      "S064": "Notice does not comply with Technical Rule 135. (S064)",
      "S067": "Message does not comply with constraint CS067. (S067)",
      "S069": "Message does not comply with constraint CS069. (S069)",
      "S072": "Message does not comply with constraint CS072. (S072)",
      "S088": "Message does not comply with constraint CS088. (S088)",
      "S089": "Message does not comply with constraint CS089. (S089)",
      "S092": "Message does not comply with constraint CS092. (S092)",
      "S093": "Message does not comply with constraint CS093. (S093)",
      "S108": "Message does not comply with Technical Rule 137. (S108)",
      "S113": "Message does not comply with constraint CS113. (S113)",
      "S118": "Message does not comply with constraint CS118. (S118)",
      "S123": "Message does not comply with constraint CS123. (S123)",
      "S125": "Message does not comply with constraint CS125 (S125)",
      "S127": "Message does not comply with constraint CS127 (S127)",
      "S130": "Message does not comply with constraint CS130 (S130)",
      "S131": "Message does not comply with constraint CS131 (S131)",
      "S132": "Message does not comply with constraint CS132 (S132)",
      "S133": "Message does not comply with constraint CS133 (S133)"
    },
    "Retry request": "Request again",
    "Score": "Score",
    "SoortIndicatie": "Kind",
    "Start_date": "Starting Date",
    "Street": "Street",
    "Type": "Type",
    "Value": "Value",
    "Vecozotoegewezenzorgzwaartepakket": "Assigned care intensity package",
    "Zorgkantoor": "Care office",
    "ZzpCode": "ZZP Code"
  },
  "Vektis_declaratie": {
    "Credit replaces concept title": "Replace draft declaration",
    "Credit replaces concept message": "A draft exists for the same month and care office. Continuing permanently deletes the entire draft below, including other clients’ lines and archived lines, and creates the credit declaration. Cancelling keeps all data.",
    "Delete concept and create credit": "Delete draft and create credit",
    "Delete concept": "Delete draft",
    "Delete concept message": "<p>Permanently delete this draft?</p><p><strong>Period:</strong> {begin} through {end}<br><strong>Revision:</strong> {revision}</p><p><strong>Will be deleted</strong><br>All draft records for all clients, including archived clients and saved choices.</p><p><strong>Will be preserved</strong><br>Attendance registrations, original declarations and credits.</p><p class=\"q-mb-none\">Creating a new draft lets you choose archived care and client data again.</p>",
    "Aantal_clienten": "Number of clients (9902)",
    "Aantal_prestaties": "Number of achievements (9904)",
    "Always_declare": "Will be declared?",
    "Beginperiode": "Starting period",
    "Betaling_aan": "Payment to (0113)",
    "Btw_id": "VAT ID (0118)",
    "Claim": "Declare",
    "Code_informatiesysteem_softwareleverancier": "Software Code (0106)",
    "Declaration already exists": "There is already a declaration for this month. Do you want to recalculate it?",
    "Delete item": "Delete declaration",
    "Delete item fail": "Error deleting the declaration.",
    "Delete item success": "Declaration successfully deleted.",
    "Deleted": "Deleted",
    "Download item success": "Claim successfully downloaded.",
    "Edit item": "Edit declaration",
    "Edit item fail": "Error when changing the declaration The declaration has not changed.",
    "Edit item success": "Declaration successfully edited.",
    "Eindperiode": "Final period",
    "Errors": {
      "DECLARATION_CARE_ASSIGNMENT_MISSING": "The care assignment for this care link is missing. Restore the assignment before recalculating this care.",
      "CLIENTS_NO_INSURANCE_SUPPLIER": "Declaration could not be made. Not all clients have set up a health insurer.",
      "DECLARATION_ALREADY_SUBMITTED": "This declaration has already been submitted as an AW319.",
      "DECLARATION_NOT_CONCEPT": "This declaration has already been finalized and cannot be deleted, even if its AW319 file has not been downloaded or the declaration was rejected.",
      "DECLARATION_GENERAL_ERROR": "Declaration could not be made. Contact the supplier for more information.",
      "NO_PRESTATIES_FOR_DECLARATION": "Declaration could not be made. There are no services to declare.",
      "OPEN_DECLARATION_EXIST": "Declaration could not be made. There is already a draft declaration for this period.",
      "PENDING_DECLARATION_EXIST": "Declaration could not be made. There is a submitted claim pending a response from Vecozo.",
      "CREDIT_RETURN_PENDING": "This correction cannot be submitted yet. Process the credit declaration's return message first. The credit must be approved in that return.",
      "CARE_ALREADY_DECLARED": "This care is already included in another declaration. Recalculate the draft and review the declaration history.",
      "CARE_REGISTRATIONS_OUTSIDE_PERIOD": "Care registrations fall outside the valid care period. Check the care link, assignment and registrations.",
      "CONCEPT_CLIENT_DATA_AMBIGUOUS": "The draft contains different client snapshots that cannot be uniquely matched to this care. The draft was not changed. Contact your supplier."
    },
    "Externe_integratie": "External Integration (0102)",
    "Factuurdatum": "Invoice date",
    "Factuurnummer": "Invoice number",
    "Force_generate": "Still make a claim for care types with \"Always declare\" and final attendance registrations.",
    "Grouped claim amounts": "Grouped claim amounts",
    "Archived declarable care warning": "There are archived clients with care left to declare in this period. If you continue, the declaration will be created without the lines for these archived clients.",
    "Archived declarable care warning title": "Archived clients with care left to declare",
    "Indicatie_debet_credit": "Indication Debit/Credit (9908)",
    "Instellingscode": "Institution code",
    "Month": "Month",
    "New item": "New declaration",
    "New item fail": "Error creating the declaration.",
    "New item success": "Declaration successfully created.",
    "Praktijkcode": "Code of Practice (0111)",
    "Reload": "Re-calculate",
    "Reserve": "Reserve (0180)",
    "Revision": "Revision",
    "Servicebureau": "Service desk (0109)",
    "Soort_bericht": "Message type (0105)",
    "Status": "Status",
    "StatusOptions": {
      "accepted": "Approved",
      "concept": "Draft",
      "partially_rejected": "Partially rejected",
      "pending": "Wait for response",
      "rejected": "Completely rejected"
    },
    "Subversie": "Subversion (0104)",
    "Tab errors": {
      "Declaration errors": "One or more client(s) have rejected claims.",
      "Unauthorized": "Insufficient rights to view this data."
    },
    "Tabs": {
      "Efforts": "Delivered performance",
      "General": "Declaration",
      "Totals": "Totals"
    },
    "Totaal_aantal_detail_records": "Total Detail Records (9906)",
    "Totaal_declaratiebedrag_cent": "Total claim amount (9907)",
    "Uzovi": "UZOVI",
    "Valuta": "Currency",
    "Vektis_uzovi": "Care office",
    "Vektis_uzovi_info": "Care Office (0108)",
    "Versie": "Version (0103)",
    "Versieaanduiding_informatiesysteem_softwareleverancier": "Software version (0107)",
    "View item": "View declaration",
    "Will be declared": "This registration is declared because \"Always declare\" is enabled. This does not depend on attendance registrations.",
    "Will not be declared": "This registration is not declared because \"Always declare\" is disabled. This depends on final attendance registrations.",
    "Year": "Year",
    "Zorgverlenerscode": "Caregiver Code (0110)",
    "ArchivedCare": {
      "Title": "Review archived care",
      "Message": "Select the care for archived clients to include in this draft. Care that has never been declared is only included after selection. Lines already included in another draft or submitted declaration cannot be selected. Missing care links are restored when the original reference is uniquely recorded.",
      "PendingCredit": "Some credits are awaiting a return. You can prepare the correction; submission requires approval of the corresponding credit.",
      "Include": "Include",
      "CareCode": "Performance code",
      "Reason": "Declaration history",
      "Registrations": "Registrations",
      "FirstRegistration": "First registration",
      "LastRegistration": "Last registration",
      "MissingSource": "Original care assignment cannot be uniquely established",
      "Skip": "Continue without this care",
      "IncludeSelection": "Include selection",
      "Reasons": {
        "never_declared": "Never declared",
        "rejected": "Previously rejected",
        "credited": "Credited",
        "credit_pending": "Credit awaiting return",
        "declaration_pending": "Declaration awaiting return",
        "existing_concept": "Existing draft",
        "approved": "Already approved"
      }
    },
    "RedeclarationClientData": {
      "Title": "Client data for redeclaration",
      "Message": "Client data has changed since the original declaration. Choose which data applies to this care period for each client. Current data is selected by default and applies to all included redeclaration lines for that client. The credit continues to mirror the original.",
      "NoChanges": "The data has changed in the meantime; there are no remaining differences for the included redeclaration lines. Continue to generate the draft.",
      "Current": "Current client data (default)",
      "Original": "Original declaration data",
      "Confirm": "Use selection",
      "Source": "Original declaration",
      "Field": "Field",
      "OriginalValue": "Original",
      "CurrentValue": "Current"
    },
    "Credit created refresh failed": "The credit was created, but the list could not be refreshed. Refresh the list to see the current status.",
    "Concept deleted refresh failed": "The draft has been deleted, but the list could not be refreshed. Refresh the list to see the current status.",
    "Recalculated refresh failed": "The draft was recalculated, but the view could not be refreshed. Reopen the draft to see the result."
  },
  "Vektis_declaratie_client": {
    "Bsn": "BSN (0203)",
    "Client": "Customer",
    "Client Effort Table": "Client performance table",
    "Client Table": "Client table",
    "ClientDeceasedOptions": {
      "1": "Client has died",
      "2": "Client has not died"
    },
    "Clientnummer_indicatieorgaan": "Client number indication body (0225)",
    "Code_indicatieorgaan": "Code indication body (0224)",
    "Credit items": "Credit items",
    "Debiteurnummer": "Debtor Number (0222)",
    "Geboortedatum": "Date of Birth (0207)",
    "Geslacht": "Genus (0208)",
    "Huisnummer": "House number (home address) insured (0219)",
    "Huisnummer_toevoeging": "House number addition (home address) insured (0220)",
    "Ident_detail": "Detail Record Identification (0202)",
    "Indicatie_client_overleden": "Indication client deceased (0223)",
    "Landcode": "Insured Country Code (0221)",
    "Naam_01": "Name of the insured (0210, 01)",
    "Naam_02": "Name of insured (0213, 02)",
    "Naamcode_01": "Name code/use of name (0209, 01)",
    "Naamcode_02": "Name code/use of name (0212, 02)",
    "Naamcode_03": "Name code/use of name (0216, 03)",
    "Patientnummer": "Patient (identification) number (0206)",
    "Postcode": "Insured Postal Code (Home Address) (0217)",
    "Postcode_buitenland": "Postal code abroad (0218)",
    "Retourcode_01": "Return code 01 (0296)",
    "Retourcode_02": "Return code 02 (0297)",
    "Retourcode_03": "Return code 03 (0298)",
    "StatusOptions": {
      "Accepted": "Approved",
      "Partially_rejected": "Partially rejected",
      "Rejected": "Completely rejected"
    },
    "Total_amount": "Claim Amount",
    "Verzekerdennummer": "Insured number (0205)",
    "Voorletters": "Initials insured (0215)",
    "Voorvoegsel_01": "Prefix insured (0211, 01)",
    "Voorvoegsel_02": "Prefix insured (0214, 02)"
  },
  "Vektis_declaratie_client_prestatie": {
    "Aanduiding_prestatiestelsel": "Performance code list designation (0416)",
    "Aantal": "Number of performances performed (0418)",
    "Begindatum": "Achievement Start Date (0414)",
    "Berekend_bedrag_eur": "Calculated amount incl. VAT (0426) [EUR]",
    "Berekend_bedrag_zorgverzekeraar_eur": "Calculated amount health insurer (0481) [EUR]",
    "Bsn": "BSN (0403)",
    "Btw_percentage_bp": "VAT percentage declaration amount (0428, basis points)",
    "Clientnummer_indicatieorgaan": "Client number indication body (0409)",
    "Code_indicatieorgaan": "Code indication body (0408)",
    "Debcred1": "Indication debit/credit (0427)",
    "Debcred2": "Indication debit/credit (0430)",
    "Debcred3": "Indication debit/credit (0482)",
    "Debcred4": "Indication debit/credit (0483)",
    "Declaratiebedrag_eur": "Declaration amount incl. VAT (0429) [EUR]",
    "Doorsturen_toegestaan": "Forwarding allowed (0407)",
    "Doorsturen_toegestaanOptions": {
      "1": "Forwarding to health insurer is allowed",
      "2": "Do not forward to health insurer at the request of the insured",
      "3": "Do not forward to health insurer at the request of the healthcare provider",
      "4": "Do not forward to health insurer at the request of the insured and the healthcare provider"
    },
    "Einddatum": "End date of achievement (0415)",
    "Functiecode": "Function Code (0412)",
    "Ident_detail": "Detail Record Identification (0402)",
    "Indicatie_aanvraagnummer": "Indication request number (0410)",
    "Indicatiebesluitnummer": "Indication decision number (0411)",
    "Machtigingsnummer": "Authorization Number (0406)",
    "Prestatiecode": "Performance Code (0417)",
    "PrestatiecodelijstOptions": {
      "55": "Performance code list Wlz/AWBZ"
    },
    "Ref_huidig": "Reference this performance record (0431)",
    "Ref_vorig": "Previous Performance Record Reference (0432)",
    "Retourcode_01": "Return code 01 (0496)",
    "Retourcode_02": "Return code 02 (0497)",
    "Retourcode_03": "Return code 03 (0498)",
    "Specialisme_behandelaar": "Specialism practitioner/executor (0421)",
    "Specialisme_voorschrijver": "Specialism prescriber/referrer (0423)",
    "Tarief_eur": "Rate of service incl. VAT (0425) [EUR]",
    "Tijdseenheid": "Time unit care period (0419)",
    "Toegekend_bedrag_eur": "Amount awarded (0483) [EUR]",
    "Verrekenpercentage": "Transfer percentage (0424)",
    "Verzekerdennummer": "Insurance number (0405)",
    "Zorgverlenerscode_behandelaar": "Caregiver code practitioner/executor (0420)",
    "Zorgverlenerscode_voorschrijver": "Caregiver code prescriber/referrer (0422)",
    "Zorgzwaartepakketcode": "Care Severity Package Code (0413)"
  },
  "Vektis_prestatie": {
    "Aaneengesloten declareren": "Consecutive claims",
    "Edit item": "Edit performance code",
    "Edit item fail": "Error changing the performance code.",
    "Edit item success": "Performance code successfully changed.",
    "Einddatum": "Finish",
    "Error loading data": "The list of performance codes could not be loaded.",
    "Group": "Group",
    "Ingangsdatum": "Effective date",
    "Is_toeslag": "Is surcharge",
    "NZa beleidsregel": "NZa policy rule",
    "Omschrijving": "Definition",
    "Prestatiecode": "Performance code",
    "Prestatiecodelijst": "Performance Code List",
    "Prestatiegroep": "Performance group",
    "Tabs": {
      "General": "General",
      "Tarieven": "Rates"
    },
    "Tarief": "Tariff",
    "Tijdseenheid": "Unit",
    "TijdseenheidOptions": {
      "dagdeel": "Half day (4 hours)",
      "etmaal": "Day",
      "minuut": "Minute",
      "tijdsonafhankelijk": "Time-independent",
      "uur": "Hour"
    },
    "Vektisprestatiegroup": "Vektis performance group",
    "ZZP codes": "Self-employed codes"
  },
  "Vektis_prestatie_group": {
    "Default_registered": "Register as present by default",
    "Delete item": "Delete performance group",
    "Delete item fail": "Error deleting the performance group.",
    "Delete item success": "Performance group successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the performance group {0}?",
    "Deleted": "Deleted",
    "Description": "Description",
    "Edit item": "Edit performance group",
    "Edit item fail": "Error changing the performance group. The performance group has not changed.",
    "Edit item success": "Performance group successfully changed.",
    "Name": "Name",
    "New item": "New performance group",
    "New item fail": "Error creating the performance group.",
    "New item success": "Performance group successfully created."
  },
  "Vektis_prestatie_tarief": {
    "Amount": "Amount",
    "Edit item": "Vektis performance rate edit",
    "Edit item fail": "Error when changing the performance rate.",
    "Edit item success": "Performance rate successfully changed.",
    "New item": "New performance rate",
    "New item fail": "Error creating the performance rate.",
    "New item success": "Performance rate successfully created.",
    "ObjectName": "Vektis performance rate",
    "Valid_from": "Valid from"
  },
  "Vektis_uzovi": {
    "End": "End date",
    "Modified": "Modified",
    "Naam": "Name",
    "Rol": "Role",
    "RolOptions": {
      "AV": "Additional insurances",
      "BN": "(CZ) for foreign insured persons residing in the Netherlands",
      "CO": "Business",
      "CV": "Central processing unit",
      "DB": "Declarant Foreign party",
      "DN": "Declarant Dutch party",
      "FZ": "Forensic Care Act (housed in the Ministry of Justice)",
      "GA": "Authorized agent",
      "IC": "Purchasing group",
      "LA": "Label",
      "NB": "in accordance with Article 69 of the ZVW, treaty beneficiaries abroad (National Health Care Institute)",
      "NV": "Branch office",
      "OV": "Executive Body of Residence on behalf of the National Health Care Institute",
      "PJ": "Preference for the benefit of Correctional Institutions",
      "RG": "Conscientious Objectors Implementation Regulation",
      "RI": "Implementation Regulation finan. care Illegals",
      "RO": "Implementation Regulation for Uninsured Persons",
      "RW": "Implementation Regulation for Defaulters",
      "VD": "Power of attorney for Declarant",
      "VO": "Liaison body",
      "ZF": "Health insurance fund",
      "ZK": "Care office",
      "ZP": "Health insurance company (private)",
      "ZR": "Sickness insurance scheme (civil servants)",
      "ZV": "Health insurer"
    },
    "Start": "Start date",
    "Uzovi": "UZOVI"
  },
  "Weight": {
    "Added by": "Added By",
    "Client": "Client",
    "Client name": "Client name",
    "Created": "Added on",
    "Date": "Date",
    "Delete": "remove",
    "Delete item": "Delete Report",
    "Delete item fail": "Error deleting report.",
    "Delete item success": "Report successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the {0}?",
    "Edit item": "Edit report",
    "Edit item fail": "Error editing the report. The report has not changed.",
    "Edit item success": "Report successfully modified.",
    "Editable_by": "Editable by",
    "Had_clothing": "Dressed",
    "Name": "Name",
    "New item": "New report",
    "New item fail": "Error adding the report.",
    "New item success": "Report successfully created.",
    "ObjectName": "Weight report | Weight reports",
    "Tabs": {
      "General": "General"
    },
    "Time": "Time",
    "Weight": "Weight"
  },
  "Wzd_registration": {
    "Action": "Action/measures",
    "Action_representative": "Remarks representative(s)",
    "Added by": "Added By",
    "Awaits": "Wait for",
    "Consideration": "Consideration",
    "Consideration_representative": "Remarks representative(s)",
    "Created": "Created",
    "Delete": "remove",
    "Delete item": "Delete Report",
    "Delete item fail": "Error deleting the eport.",
    "Delete item success": "Report successfully deleted.",
    "Delete item text": "Are you sure you want to {1} the {0}?",
    "Document is cancelled": "The document has expired.",
    "Document is expired": "Please note: the validity of the document has expired!",
    "Document is final": "The document has been finalized and can no longer be changed.",
    "Documents awaits signing by representative": "The document is pending signature of the representative and can no longer be changed.",
    "Documents awaits signing by supplier": "The document is pending signature by Nocht and Wille and can no longer be changed.",
    "Edit item": "Edit report",
    "Edit item fail": "Error editing the report. The report has not changed.",
    "Edit item success": "Report successfully modified.",
    "Editable_by": "Editable by",
    "Errors": {
      "EMPLOYEE_SIGN_CONSENT": "You must give your consent before you can sign the document.",
      "REPRESENTATIVE_SIGN_CONSENT": "You must give your consent before you can sign the document."
    },
    "Is_resistance": "Is there any resistance?",
    "Is_resistance_representative": "Is there any resistance? (representative)",
    "Modified": "Last modified",
    "New item": "New report",
    "New item fail": "Error adding the report.",
    "New item success": "Report successfully created.",
    "Only editable by representative": "The document can currently only be changed by representatives.",
    "Only editable by supplier": "The document can currently only be changed by Nocht and Wille.",
    "ShowArchived": "Show archived items",
    "Sign_consent": "Document consent",
    "Sign_consent_text": "I confirm that I have read this document and agree with its contents as described.",
    "Signed": "Signed on",
    "Signed_by_employee": "Sign on behalf of Nocht en Wille Zorg B.V.",
    "Signed_by_representative": "Signing on behalf of client",
    "Status": "Status",
    "StatusOptions": {
      "CANCELLED": "Expired",
      "CONCEPT": "Concept",
      "EXPIRED": "Expired",
      "FINAL": "Definitive",
      "SIGN_EMPLOYEE": "Signing (employee)",
      "SIGN_REPRESENTATIVE": "Signing (representative)",
      "SUPERSEDED": "Superseded"
    },
    "Valid until": "Valid until",
    "WZD registration": "WZD registration"
  },
  "Yes": "Yes"
}
